import React, { PureComponent } from "react";
import { goBack } from "react-router-redux";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import {
  fetchBudget,
  cloneAndSavedBudget,
  updateBudgetClient,
  fetchSquadsSuggestions,
  fetchClusterSuggestions,
  fetchBusinessUnitSuggestions
} from "Thunks";

import { DIALOG_TYPES } from "Config";
import TTPDialog from "../Common/TTPDialog";
import {
  setBudgetPeriodeSetting,
  setBudgetData,
  setBudgetYear,
  setCollaborators
} from "Actions";
import {
  onError,
  onSuccess,
  getFormatNumber,
  getBudgetNumberFormat,
  // getBudgetNumberLabelFormat,
  toFixed,
  toNumber
} from "Utils";
import Select from "react-select";
import { Button, Switch, Tooltip } from "antd";
import { TiWarningOutline } from "react-icons/ti";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";

import { STATES, BUDGET_STATUS, YEARS_VALUES } from "Config";
import styles from "./BudgetSettings.local.scss";
import styles2 from "../Budget/BudgetModal.local.scss";
import {
  DoubleArrowUp,
  PlusIcon,
  ResetIcon,
  CheckMarkIcon,
  Garbage
} from "../Common/Icons";
import AsyncSelect from "react-select/lib/Async";
import { Alert } from "antd";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { NotificationManager } from "react-notifications";
import { DescriptiveContainer } from "../Common/DescriptiveContainer/DescriptiveContainer";
import NumberFormat from "react-number-format";

class BudgetSettings extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filterFormIsVisible: false,
      budget: null,
      oldPeriodSetting: null,
      levelStates: {
        level1: [],
        level2: [],
        level3: [],
        level4: []
      },
      cloneType: null,
      warnings: {},
      alerts: {},
      modifiedLevel: null,
      activatedLevel: null,
      selectedCategories: [],
      collaboratorOptions: [],
      displayConfirmation: false,
      selectedZoneIds: [],
      totalCategoriesBudget: 0,
      exceededBudgetRate: 0,
      fetchingLevel: false,
      budgetState: "",
      totalDelegationsBudget: 0,
      selectedZones: [],
      yearDivIsVisible: false,
      year: this.props.year,
      categoriesBudgetLeft: 0,
      budgetEco: ""
    };
  }

  componentDidUpdate(prevProps, prevState) {
    let { budget, selectedCategories } = this.state;
    let { budgetData, fetchedCollaborators } = this.props;

    if (budgetData !== null && budget === null && fetchedCollaborators) {
      this.prepareBudgetStates();
    }

    if (
      prevProps.periodSetting !== this.props.periodSetting &&
      prevState.modifiedLevel === this.state.modifiedLevel
    ) {
      this.setState({ ...this.state, modifiedLevel: "LEVEL_1" });
    }
    if (
      (budget &&
        prevState.budget &&
        (prevState.budget.supervisor.value !== budget.supervisor.value ||
          prevState.budget.totals.actualYearBudget !==
            budget.totals.actualYearBudget)) ||
      (prevState.budget === null && budget)
    ) {
      this.checkZonesBudgetState();
    }

    if (
      prevState.selectedCategories.length === 0 &&
      selectedCategories.length > 0
    ) {
      this.calculateTotalBudgets();
    }
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  changeActivatedLevel = level => {
    const { activatedLevel } = this.state;

    if (level === activatedLevel) return;

    const nbr = level.substring(6);
    this.setState({ activatedLevel: `LEVEL_${nbr}` }, () =>
      this.scrollToNode(`level${nbr}`)
    );
  };

  //**********************************************************//
  //******************   Content Functions  **************//
  //**********************************************************//

  //******************   Initiate States functions  **************//
  prepareBudgetStates = (resetLevel = true) => {
    let {
      budgetData,
      collaborators,
      fetchedCollaborators,
      categories,
      dispatch
    } = this.props;
    let {
      zones,
      supervisor: { value }
    } = budgetData;
    let zonesIds = [];
    let selectedZones = [];
    let selectedCategories = [];
    let totalDelegations = 0;
    let totalCategories = 0;

    Object.keys(zones).map(function(key, index) {
      zonesIds.push(zones[key].id);
      let totalActualYear = 0;
      let totalLastYear = 0;
      let totalRealTime = 0;
      let totalCategories = 0;
      let collaboratorOptions = [];

      budgetData.categories.forEach(categoryZone => {
        if (
          categoryZone.zone === zones[key].id &&
          categoryZone.bases.actualYear
        ) {
          totalCategories += parseFloat(categoryZone.bases.actualYear);
        }
        if (
          categoryZone.zone === zones[key].id &&
          categoryZone.bases.realTime
        ) {
          totalRealTime += parseFloat(categoryZone.bases.realTime);
        }
        if (
          categoryZone.zone === zones[key].id &&
          categoryZone.bases.lastYear
        ) {
          totalLastYear += parseFloat(categoryZone.bases.lastYear);
        }
      });
      zones[key].collaborators.delegated.forEach(collaborator => {
        totalActualYear += parseFloat(collaborator.base || "0");
      });
      totalActualYear +=
        parseFloat(zones[key].collaborators.principal.base || "0") +
        toNumber(value);
      if (fetchedCollaborators) {
        collaboratorOptions =
          collaborators &&
          collaborators
            .filter(collaborator => collaborator.zone === zones[key].id)
            .map(collaborator => {
              return {
                label: collaborator.name,
                value: collaborator.id,
                zone: collaborator.zone,
                affectedBudget: collaborator.affectedBudget
              };
            });
      }
      totalDelegations += zones[key].total.total;

      selectedZones.push({
        id: zones[key].id,
        label: zones[key].label,
        collaborators: {
          principal: {
            ...zones[key].collaborators.principal,
            role: zones[key].id === 1 ? "GD" : "GE"
          },
          delegated: zones[key].collaborators.delegated.slice(0)
        },
        collaboratorOptions,
        total: {
          totalActualYear: parseFloat(totalActualYear).toFixed(2),
          totalCategories,
          totalLastYear,
          totalRealTime,
          total: zones[key]["total"]["total"]
        },
        responsibles: zones[key]["responsibles"],
        delegation: zones[key].collaborators.delegated.length > 0
      });
      return key;
    });

    categories.forEach(category => {
      let totalByCategory = 0;
      let zones = [];
      budgetData.categories.forEach(categoryZone => {
        if (categoryZone.id === category.id) {
          totalByCategory += parseFloat(categoryZone.bases.actualYear);
          zones.push({
            id: category.id,
            zone: categoryZone.zone,
            bases: {
              actualYear: categoryZone.bases.actualYear,
              lastYear: categoryZone.bases.lastYear,
              realTime: categoryZone.bases.realTime
            }
          });
        }
      });

      totalCategories += totalByCategory;

      selectedCategories.push({
        id: category.id,
        label: category.label,
        zones: zones,
        total: totalByCategory ? totalByCategory : 0
      });
    });

    let newcollaborators =
      collaborators &&
      collaborators.map(collaborator => {
        return {
          label: collaborator.name,
          value: collaborator.id,
          budget: collaborator.affectedBudget,
          zone: collaborator.zone
        };
      });

    this.setState(
      {
        ...this.state,
        totalDelegationsBudget: parseFloat(totalDelegations.toFixed(2)),
        totalCategoriesBudget: Number.isNaN(totalCategories)
          ? parseFloat(totalCategories.toFixed(2))
          : 0,
        budget: budgetData,
        selectedCategories: selectedCategories,
        collaboratorOptions: newcollaborators,
        selectedZoneIds: [...zonesIds],
        selectedZones: selectedZones,
        modifiedLevel: null,
        oldPeriodSetting: null,
        alerts: {},
        warnings: {}
      },
      () => {
        /** important to uncomment this code later on */
        budgetData &&
          selectedZones &&
          this.checkZonesBudgetState(this.calculateTotalBudgets);

        if (resetLevel) {
          this.initiateLevelsStates();
        } else {
          // Pour retourner au précédent periodSetting
          if (this.state.oldPeriodSetting) {
            dispatch(setBudgetPeriodeSetting(this.state.oldPeriodSetting));
            this.setState({
              ...this.state,
              totalDelegationsBudget: parseFloat(totalDelegations.toFixed(2)),
              totalCategoriesBudget: parseFloat(totalCategories.toFixed(2)),
              budget: this.props.budgetData,
              selectedCategories: selectedCategories,
              collaboratorOptions: newcollaborators,
              selectedZoneIds: [...zonesIds],
              selectedZones: selectedZones,
              modifiedLevel: null,
              warnings: {},
              oldPeriodSetting: null
            });
          }
        }
      }
    );
  };

  initiateLevelsStates = () => {
    let {
      budget,
      totalCategoriesBudget,
      selectedZones,
      selectedZoneIds
    } = this.state;
    let activatedLevel = null;
    let levelStates = {};
    let clientBudgetState = this.props.periodSetting.budgetState;

    if (
      !budget.totals.actualYearEconomicBudget ||
      budget.totals.actualYearEconomicBudget === 0
    ) {
      this.setState({ budgetEco: _("budgetEcoManquant") });
    } else {
      this.setState({ budgetEco: "" });
    }

    if (clientBudgetState === "GLOBAL_BUDGET_NOT_AFFECTED") {
      //Level 1
      activatedLevel = "LEVEL_1";
      this.scrollToNode("level1");
    }

    if (
      selectedZoneIds &&
      selectedZoneIds.length === 0 &&
      activatedLevel === null
    ) {
      //Level 2
      activatedLevel = "LEVEL_2";
      this.scrollToNode("level2");
    }

    // TODO a decommenter pour apres
    // if (
    //   !selectedZones ||
    //   selectedZones.length === 0 ||
    //   selectedZones.find(item => item.collaborators.principal.id === null)
    // ) {
    //   //Level 3
    //   activatedLevel = "LEVEL_3";
    // }

    // if (activatedLevel === null) {
    //   //Level 4
    //   activatedLevel = "LEVEL_4";
    // }

    if (
      clientBudgetState === "BUDGET_BY_ZONE_AFFECTED" ||
      clientBudgetState === "BUDGET_ZONE_DELEGATION_AFFECTED" ||
      clientBudgetState === "DELEGATION_NOT_AFFECTED" ||
      clientBudgetState === "GLOBAL_BUDGET_AFFECTED"
    ) {
      //Level 3
      activatedLevel = "LEVEL_3";
      this.scrollToNode("level3");
    }

    if (
      clientBudgetState === "BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED" ||
      clientBudgetState === "BUDGET_COMPLETED"
    ) {
      //Level 4 ( Change level 3 to 4 when uncommenting 4th bloc )
      activatedLevel = "LEVEL_3";
      this.scrollToNode("level3");
    }

    //Level 1
    levelStates =
      budget && budget.totals.actualYearBudget > 0
        ? { ...levelStates, level1: [STATES.VALID] }
        : { ...levelStates, level1: [STATES.NOT_VALID] };

    //Level 2
    levelStates =
      selectedZoneIds && selectedZoneIds.length > 0
        ? { ...levelStates, level2: [STATES.VALID] }
        : { ...levelStates, level2: [STATES.NOT_VALID] };

    //Level 3
    levelStates =
      selectedZones &&
      selectedZones.length > 0 &&
      selectedZoneIds.length === selectedZones.length &&
      !selectedZones.find(item => item.collaborators.principal.id === null)
        ? { ...levelStates, level3: [STATES.VALID] }
        : { ...levelStates, level3: [STATES.NOT_VALID] };

    //Level 4
    levelStates =
      selectedZones && selectedZones.length > 0
        ? budget.categories &&
          budget.categories.length > 0 &&
          totalCategoriesBudget === budget.totals.actualYearBudget
          ? { ...levelStates, level4: [STATES.VALID] }
          : {
              ...levelStates,
              level4: [STATES.NOT_VALID]
            }
        : { ...levelStates, level4: [STATES.NOT_VALID] };

    this.setState({
      levelStates: levelStates,
      activatedLevel: activatedLevel
    });
  };

  //*************   General functions  *******************//
  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(setBudgetYear(year));
    dispatch(fetchBudget()).then(res => this.prepareBudgetStates());

    const params = new Map(
      window.location.search
        .slice(1)
        .split("&")
        .map(kv => kv.split("="))
    );
    if (params.has("year")) {
      const url = new URL(window.location);
      url.searchParams.set("year", year);
      window.history.pushState({}, "", url);
    }
  };

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{ marginLeft: 10 }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {YEARS_VALUES.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderBudgetSettingTitle = () => {
    const { clientName } = this.props;
    const { year } = this.state;
    return (
      <div className={styles.header}>
        <div className={styles.title_bar}>
          <div className={styles.title_bar_title}>
            <span>{clientName} </span>
            {_("forYear")} <span>{year}</span>
          </div>
        </div>
        <div className={styles.years_select}>{this.renderYearSelect()}</div>
      </div>
    );
  };

  handlePreviousLevel = id => {
    const nbr = parseInt(id.substring(6), 10);

    const level = `LEVEL_${nbr - 1}`;

    this.scrollToNode(`level${nbr - 1}`);

    this.resetBudgetState();
    this.setState({
      activatedLevel: level
    });
  };

  renderClickValidateLevelState = id => {
    let { alerts } = this.state;
    switch (id) {
      case "LEVEL_1":
        return alerts.level1 && alerts.level1.isRequired;
      case "LEVEL_2":
        return alerts.level2 && alerts.level2.isRequired;
      case "LEVEL_3":
        return alerts.level3 && alerts.level3.isRequired;
      case "LEVEL_4":
        return alerts.level4 && alerts.level4.isRequired;
      default:
        return;
    }
  };

  renderClickNextLevelState = id => {
    this.renderValidatedLevelState(id, STATES.NOT_VALID);
  };

  handleNextLevel = id => {
    const nbr = parseInt(id.substring(6), 10);

    const level = `LEVEL_${nbr + 1}`;

    this.setState(
      {
        activatedLevel: level
      },
      () => this.scrollToNode(`level${nbr + 1}`)
    );
  };

  resetBudgetState = () => {
    this.prepareBudgetStates(false);
  };

  //*************   Clone functions  ********************//
  displayCloneBudgetModal = type => {
    let { budgetData } = this.props;
    if (budgetData.id !== null) {
      this.setState({
        ...this.state,
        cloneType: type,
        displayConfirmCloneModal: true
      });
    } else {
      this.handleCloneBudget(type);
    }
  };

  handleCloneBudget = base => {
    let budget = {
      budget: this.props.budgetData.id,
      client: this.props.client.id,
      year: this.state.year,
      base: base ? base : this.state.cloneType
    };
    this.props
      .dispatch(cloneAndSavedBudget(budget))
      .then(res => {
        onSuccess(res, {
          title: _("cloneSuccess"),
          body: _("budgetCloned")
        });
        this.props.dispatch(fetchBudget()).then(res => {
          this.prepareBudgetStates();
        });
        this.setState({
          ...this.state,
          displayConfirmCloneModal: false
        });
      })
      .catch(error => {
        onError(_("errorOccured"));
        this.setState({
          displayConfirmCloneModal: false
        });
      });
  };

  // for SQUAD select
  handleChangeSquad = selected => {
    if (!this.state.oldPeriodSetting)
      this.setState({
        ...this.state,
        oldPeriodSetting: this.props.periodSetting
      });
    let periodSetting = {
      ...this.props.periodSetting,
      squad: {
        squadId: selected.value,
        squadName: selected.label
      }
    };

    this.props.dispatch(setBudgetPeriodeSetting(periodSetting));
  };

  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };
  // for CLUSTER select
  handleChangeCluster = selected => {
    if (!this.state.oldPeriodSetting)
      this.setState({
        ...this.state,
        oldPeriodSetting: this.props.periodSetting
      });

    let periodSetting = {
      ...this.props.periodSetting,
      cluster: {
        clusterId: selected.value,
        clusterName: selected.label
      }
    };

    this.props.dispatch(setBudgetPeriodeSetting(periodSetting));
  };

  loadClusterSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClusterSuggestions(searchWord))
      .then(res => {
        const clusters = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(clusters);
      })
      .catch(er => {
        callback([]);
      });
  };

  // for BU select
  handleChangeBU = selected => {
    if (!this.state.oldPeriodSetting)
      this.setState({
        ...this.state,
        oldPeriodSetting: this.props.periodSetting
      });
    let periodSetting = {
      ...this.props.periodSetting,
      businessUnit: {
        businessUnitId: selected.value,
        businessUnitName: selected.label
      }
    };
    this.props.dispatch(setBudgetPeriodeSetting(periodSetting));
  };

  loadBusinessUnitSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchBusinessUnitSuggestions(searchWord))
      .then(res => {
        const businessUnits = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(businessUnits);
      })
      .catch(er => {
        callback([]);
      });
  };

  scrollToNode = id => {
    let element = document.getElementById(id);
    var offSet = -65;
    var elementPosition = element.offsetTop;
    var offsetPosition = elementPosition + offSet;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  };

  //*************   Render levels functions  ***********//
  renderBudgetSettingLevels = () => {
    const {
      // categories,
      zoneData,
      fetched,
      periodSetting,
      parameterSettings: { synchroRole }
      // year
    } = this.props;
    let {
      year,
      budget,
      alerts,
      warnings,
      // categoriesBudgetLeft,
      totalDelegationsBudget,
      // levelStates,
      activatedLevel,
      // selectedCategories,
      collaboratorOptions,
      selectedZones,
      selectedZoneIds,
      exceededBudgetRate,
      fetchingLevel
    } = this.state;

    fetched
      ? this.setState({
          ...this.state,
          myPeriodSetting: this.props.periodSetting
        })
      : this.setState({
          ...this.state
        });

    let status1 = "";
    let status2 = "";
    let status3 = "";
    // let status4 = "";
    let currentState = "";
    let clientBudgetState = this.props.periodSetting.budgetState;
    let { budgetState, budgetEco } = this.state;
    if (budgetState !== "") {
      clientBudgetState = budgetState;
    }

    switch (clientBudgetState) {
      case "GLOBAL_BUDGET_NOT_AFFECTED": {
        status1 = _("globalBudgetNotAffected");
        currentState = "LEVEL_1";
        break;
      }
      case "GLOBAL_BUDGET_AFFECTED": {
        status3 = _("globalBudgetAffected");
        currentState = "LEVEL_3";
        break;
      }
      case "BUDGET_BY_ZONE_AFFECTED": {
        status3 = _("budgetByZoneAffected");
        currentState = "LEVEL_3";
        break;
      }
      case "BUDGET_ZONE_DELEGATION_AFFECTED": {
        status3 = _("budgetZoneDelegationAffected");
        currentState = "LEVEL_3";
        break;
      }
      case "DELEGATION_NOT_AFFECTED": {
        status3 = _("delegationNotAffected");
        currentState = "LEVEL_3";
        break;
      }
      // case "BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED": {
      //   status4 = _("budgetZoneByCategoryNotCompleted");
      //   currentState = "LEVEL_4";
      //   break;
      // }
      // case "BUDGET_COMPLETED": {
      //   status4 = _("budgetCompleted");
      //   currentState = "LEVEL_4";
      //   break;
      // }
      default: {
      }
    }
    return (
      <div
        className={classnames("columns medium-12 small-12", styles.list_items)}
      >
        <div id="level1" key="level_1" className={styles.item}>
          <div
            className={styles.item_body}
            onClick={() => this.changeActivatedLevel("LEVEL_1")}
          >
            <div
              className={`${styles.item_body_level} ${
                styles.item_body_level_1
              } ${
                // levelStates.level1.includes(STATES.VALID)
                activatedLevel === "LEVEL_1" ? styles.valid : styles.unvalid
              }
              ${
                activatedLevel === "LEVEL_1" ? styles.unlocked : styles.locked
              }`}
            >
              <div className={styles.component1}>
                <div
                  className={`${
                    activatedLevel === "LEVEL_1"
                      ? classnames(styles.cercleInitial, styles.cercleEnable)
                      : classnames(styles.cercleInitial, styles.cercleDisable)
                  }`}
                  onClick={() => this.changeActivatedLevel("LEVEL_1")}
                />
                <span
                  className={`${
                    currentState !== "LEVEL_1" && activatedLevel === "LEVEL_1"
                      ? classnames(styles.ligneInitial, styles.ligne1)
                      : activatedLevel === "LEVEL_1"
                        ? styles.ligneInitial
                        : classnames(styles.ligneInitial, styles.ligne1)
                  }`}
                />
                <p
                  onClick={() => this.changeActivatedLevel("LEVEL_1")}
                  className={styles.budget_state_title}
                >
                  {_("budgetGlobal")}
                </p>
                <span
                  className={styles.budget_state_sous_titre}
                  style={{ fontSize: 12 }}
                >
                  {status1}
                </span>

                <TiWarningOutline
                  className={`${
                    budgetEco !== "" && status1 !== ""
                      ? styles.icon_initial
                      : budgetEco === ""
                        ? classnames(styles.icon_initial, styles.icon_hidden)
                        : classnames(styles.icon_initial, styles.icon)
                  }`}
                />

                <span
                  className={`${
                    budgetEco !== "" && status1 !== ""
                      ? styles.budget_state_eco_initial
                      : classnames(
                          styles.budget_state_eco_initial,
                          styles.budget_state_eco
                        )
                  }`}
                  style={{ fontSize: 12 }}
                >
                  {budgetEco}
                </span>
              </div>
              {warnings.level1 && (
                <div className={styles.alert_container}>
                  <Alert
                    message={warnings.level1.comment}
                    type="error"
                    showIcon
                  />
                </div>
              )}
              <div className={classnames("", styles2.form_group)}>
                <div className={styles2.select_dev}>
                  <span>{_("squad")} </span>
                  <AsyncSelect
                    value={{
                      value: periodSetting && periodSetting.squad.squadId,
                      label: periodSetting && periodSetting.squad.squadName,
                      color: "#000"
                    }}
                    key={periodSetting && periodSetting.squad.squadId + "squad"}
                    isMulti={false}
                    placeholder={_("Selectionner le Squad")}
                    onChange={e => this.handleChangeSquad(e)}
                    classNamePrefix="ttp-select"
                    isDisabled={activatedLevel !== "LEVEL_1"}
                    defaultOptions
                    loadOptions={this.loadSquadSuggestions}
                    className={`ttp-select empty-box`}
                  />
                </div>
                <div className={styles2.select_dev}>
                  <span>{_("Cluster")} </span>
                  <AsyncSelect
                    value={{
                      value: periodSetting && periodSetting.cluster.clusterId,
                      label: periodSetting && periodSetting.cluster.clusterName,
                      color: "#000"
                    }}
                    key={
                      periodSetting &&
                      periodSetting.cluster.clusterId + "cluster"
                    }
                    isMulti={false}
                    placeholder={_("Selectionner le Cluster")}
                    onChange={e => this.handleChangeCluster(e)}
                    classNamePrefix="ttp-select"
                    isDisabled={activatedLevel !== "LEVEL_1"}
                    defaultOptions
                    loadOptions={this.loadClusterSuggestions}
                    className={`ttp-select empty-box`}
                  />
                </div>
                <div className={styles2.select_dev}>
                  <span>{_("BU")} </span>
                  <AsyncSelect
                    value={{
                      value:
                        periodSetting &&
                        periodSetting.businessUnit.businessUnitId,
                      label:
                        periodSetting &&
                        periodSetting.businessUnit.businessUnitName,
                      color: "#000"
                    }}
                    key={
                      periodSetting &&
                      periodSetting.businessUnit.businessUnitId + "BU"
                    }
                    isMulti={false}
                    placeholder={_("Selectionner la BU")}
                    onChange={e => this.handleChangeBU(e)}
                    classNamePrefix="ttp-select"
                    isDisabled={activatedLevel !== "LEVEL_1"}
                    defaultOptions
                    loadOptions={this.loadBusinessUnitSuggestions}
                    className={`ttp-select empty-box`}
                  />
                </div>
              </div>
              <div
                className={styles.item_body_level_1_line}
                style={{ display: "flex", alignItems: "flex-start" }}
              >
                <label
                  style={{
                    minWidth: 180,
                    paddingBottom: 10,
                    margin: "0px 20px 10px 90px",
                    borderBottom: "1px solid rgb(109 127 146 / 30%)"
                  }}
                >
                  {_("budget")} {year}:
                </label>
                <label
                  style={{
                    minWidth: 180,
                    paddingBottom: 10,
                    margin: "0px 20px 10px 25px",
                    borderBottom: "1px solid rgb(109 127 146 / 30%)"
                  }}
                >
                  {_("budget")} {year - 1}:
                </label>
                <label
                  style={{
                    minWidth: 180,
                    paddingBottom: 10,
                    margin: "0px 20px 10px 25px",
                    borderBottom: "1px solid rgb(109 127 146 / 30%)"
                  }}
                >
                  {_("realized")} {year - 1} :
                </label>
              </div>
              <div
                className={styles.item_body_level_1_line}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  paddingTop: 0
                }}
              >
                <label
                  style={{
                    minWidth: 80,
                    alignSelf: "center"
                  }}
                >
                  {_("unit")} H :
                </label>
                <DescriptiveContainer
                  label={_("globalBudgetLeft")}
                  indicator={exceededBudgetRate.toFixed(2)}
                >
                  <div className={styles.input_frame}>
                    <input
                      type="number"
                      value={
                        budget &&
                        budget.totals &&
                        budget.totals.actualYearBudget
                          ? budget.totals.actualYearBudget
                          : ""
                      }
                      placeholder={_("setBudgetGlobal")}
                      onChange={e => this.handleChangeBudgetHoursTotal(e)}
                      onBlur={e => this.handleChangeBudgetHoursTotal(e, true)}
                      disabled={activatedLevel !== "LEVEL_1"}
                      required={true}
                    />
                  </div>
                </DescriptiveContainer>
                <Tooltip
                  key={`lastYearBudget`}
                  placement="top"
                  title={_("Budget de l'année précédente")}
                >
                  <div
                    className={`${styles.indice_frame} ${
                      styles.indice_frame_1
                    }`}
                  >
                    {budget && getFormatNumber(budget.totals.lastYearBudget)}{" "}
                    {_("Hours")}
                  </div>
                </Tooltip>
                <Tooltip
                  key={`lastYearReleased`}
                  placement="top"
                  title={_("Temps realisé de l'année précédente")}
                >
                  <div
                    className={`${styles.indice_frame} ${
                      styles.indice_frame_2
                    }`}
                  >
                    {budget && getFormatNumber(budget.totals.lastYearReleased)}{" "}
                    {_("Hours")}
                  </div>
                </Tooltip>
                <Tooltip
                  key={`budgetProgress`}
                  placement="top"
                  title={_("Progres de répartition du budget actuel")}
                >
                  <div
                    style={{
                      height: "38px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.progress_container}>
                      <div
                        className={styles.progress_bar}
                        style={{
                          width:
                            budget &&
                            budget.totals &&
                            budget.totals.actualYearBudget > 0
                              ? parseInt(
                                  (totalDelegationsBudget /
                                    budget.totals.actualYearBudget) *
                                    200,
                                  10
                                )
                              : 0
                        }}
                      />
                    </div>
                    <span>
                      {budget &&
                      budget.totals &&
                      budget.totals.actualYearBudget > 0
                        ? parseInt(
                            (totalDelegationsBudget /
                              budget.totals.actualYearBudget) *
                              100,
                            10
                          )
                        : 0}%
                    </span>
                  </div>
                </Tooltip>
              </div>
              <div className={styles.item_body_level_1_line}>
                <label style={{ minWidth: 80 }}>{_("unit")} €:</label>
                <div className={styles.input_frame}>
                  <input
                    type="number"
                    value={
                      budget &&
                      budget.totals &&
                      budget.totals.actualYearEconomicBudget
                        ? budget.totals.actualYearEconomicBudget
                        : ""
                    }
                    placeholder={_("setEconomicBudget")}
                    onChange={e => this.handleChangeEconomicBudget(e)}
                    onBlur={e => this.handleChangeEconomicBudget(e, true)}
                    disabled={activatedLevel !== "LEVEL_1"}
                    required={true}
                  />
                </div>
                <Tooltip
                  key={`lastYearBudget`}
                  placement="top"
                  title={_("Budget economic de l'année précédente")}
                >
                  <div
                    className={`${styles.indice_frame} ${
                      styles.indice_frame_1
                    }`}
                  >
                    {budget && budget.totals.lastYearEconomicBudget} {_("€")}
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
          {this.renderBudgetLevelFooter("LEVEL_1")}
        </div>
        <div id="level2" key="level_2" className={styles.item}>
          <div
            className={styles.item_body}
            onClick={() => this.changeActivatedLevel("LEVEL_2")}
          >
            {fetchingLevel === "LEVEL_2" ? (
              this.renderRipple()
            ) : (
              <div
                className={`${styles.item_body_level} ${
                  styles.item_body_level_2
                } ${
                  // levelStates.level2.includes(STATES.VALID)
                  activatedLevel === "LEVEL_2" ? styles.valid : styles.unvalid
                }
                ${
                  activatedLevel === "LEVEL_2" ? styles.unlocked : styles.locked
                }
              }`}
              >
                <div
                  className={classnames(styles.component1, styles.component2)}
                >
                  <div
                    className={`${
                      (currentState === "LEVEL_3" ||
                        currentState === "LEVEL_4") &&
                      activatedLevel !== "LEVEL_2"
                        ? classnames(styles.cercleInitial, styles.cercleDisable)
                        : activatedLevel === "LEVEL_2"
                          ? classnames(
                              styles.cercleInitial,
                              styles.cercleEnable
                            )
                          : activatedLevel === "LEVEL_1"
                            ? styles.cercleInitial
                            : classnames(
                                styles.cercleInitial,
                                styles.cercleDisable
                              )
                    } `}
                    onClick={() => this.changeActivatedLevel("LEVEL_2")}
                  />

                  <span
                    className={`${
                      (currentState === "LEVEL_3" ||
                        currentState === "LEVEL_4") &&
                      activatedLevel !== "LEVEL_3"
                        ? classnames(styles.ligneInitial, styles.ligne2)
                        : activatedLevel === "LEVEL_1" ||
                          activatedLevel === "LEVEL_2"
                          ? styles.ligneInitial
                          : classnames(styles.ligneInitial, styles.ligne2)
                    } `}
                  />
                  <p
                    className={`${
                      (currentState === "LEVEL_3" ||
                        currentState === "LEVEL_4") &&
                      activatedLevel !== "LEVEL_3"
                        ? styles.budget_state_title
                        : activatedLevel === "LEVEL_1"
                          ? styles.budget_state_title_initial
                          : styles.budget_state_title
                    } `}
                    onClick={() => this.changeActivatedLevel("LEVEL_2")}
                  >
                    {_("affectationBudgetaire")}
                  </p>
                  <span
                    className={styles.budget_state_sous_titre}
                    style={{ fontSize: 12 }}
                  >
                    {status2}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start"
                  }}
                >
                  {warnings.level2 && (
                    <div className={styles.alert_container}>
                      <Alert
                        message={warnings.level2.comment}
                        type="error"
                        showIcon
                      />
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      alignSelf: "flex-start"
                    }}
                  >
                    <label>{_("zones")} :</label>
                    <div>
                      <div className={styles.item_body_level_2_content}>
                        {zoneData.data &&
                          zoneData.data.zones &&
                          zoneData.data.zones.map(zone => {
                            return (
                              <div
                                className={`columns ${styles.check_frame}`}
                                key={`check-${zone.id}`}
                              >
                                <span>{zone.label}</span>
                                <div className={styles.switch_frame}>
                                  <Switch
                                    id={zone.id}
                                    checked={selectedZoneIds.includes(zone.id)}
                                    onChange={() =>
                                      this.handleSelectZone(zone.id)
                                    }
                                    disabled={
                                      activatedLevel !== "LEVEL_2" ||
                                      this.props.parameterSettings.synchroRole
                                    }
                                  />
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {this.renderBudgetLevelFooter("LEVEL_2")}
        </div>
        <div id="level3" key="level_3" className={styles.item}>
          <div
            className={styles.item_body}
            onClick={() => this.changeActivatedLevel("LEVEL_3")}
          >
            <div
              className={`${styles.item_body_level} ${
                styles.item_body_level_3
              } ${
                // levelStates.level3.includes(STATES.VALID)
                activatedLevel === "LEVEL_3" ? styles.valid : styles.unvalid
              }
              ${
                activatedLevel === "LEVEL_3" ? styles.unlocked : styles.locked
              }`}
            >
              <div className={classnames(styles.component1, styles.component3)}>
                <div
                  className={`${
                    (currentState === "LEVEL_3" ||
                      currentState === "LEVEL_4") &&
                    activatedLevel !== "LEVEL_3"
                      ? classnames(styles.cercleInitial, styles.cercleDisable)
                      : activatedLevel === "LEVEL_3"
                        ? classnames(styles.cercleInitial, styles.cercleEnable)
                        : activatedLevel === "LEVEL_1" ||
                          activatedLevel === "LEVEL_2"
                          ? styles.cercleInitial
                          : classnames(
                              styles.cercleInitial,
                              styles.cercleDisable
                            )
                  }`}
                  onClick={() => this.changeActivatedLevel("LEVEL_3")}
                />
                <span
                  className={`${
                    currentState === "LEVEL_4" && activatedLevel !== "LEVEL_4"
                      ? classnames(styles.ligneInitial, styles.ligne3)
                      : activatedLevel === "LEVEL_1" ||
                        activatedLevel === "LEVEL_2" ||
                        activatedLevel === "LEVEL_3"
                        ? classnames(styles.ligneInitial, styles.ligne3) //to de lete styles.ligne3 later on
                        : classnames(styles.ligneInitial, styles.ligne3)
                  } `}
                />
                <p
                  className={`${
                    (currentState === "LEVEL_3" ||
                      currentState === "LEVEL_4" ||
                      currentState === "LEVEL_2") &&
                    activatedLevel !== "LEVEL_3"
                      ? styles.budget_state_title
                      : activatedLevel === "LEVEL_1" ||
                        activatedLevel === "LEVEL_2"
                        ? styles.budget_state_title_initial
                        : styles.budget_state_title
                  } `}
                  onClick={() => this.changeActivatedLevel("LEVEL_3")}
                >
                  {_("budgetParCat")}
                </p>
                <span
                  className={styles.budget_state_sous_titre}
                  style={{ fontSize: 12 }}
                >
                  {status3}
                </span>
              </div>
              {warnings.level3 && (
                <div className={styles.alert_container}>
                  <Alert
                    message={warnings.level3.comment}
                    type="error"
                    showIcon
                  />
                </div>
              )}
              <div
                className={classnames(styles2.form_group)}
                style={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "2%"
                }}
              >
                <div
                  className={styles2.select_dev}
                  style={{ margin: 0, marginBottom: 7, flex: "0 0 32%" }}
                >
                  <span>{_("SUPERVISOR")} </span>

                  <Select
                    isMulti={false}
                    isSearchable={false}
                    isClearable={false}
                    closeMenuOnSelect
                    placeholder={"Collaborator"}
                    options={
                      activatedLevel === "LEVEL_3"
                        ? this.renderCustomCollaborators()
                        : []
                    }
                    value={
                      collaboratorOptions.length > 0 &&
                      periodSetting["collaborators"]["supervisor"] &&
                      collaboratorOptions.find(
                        obj =>
                          obj.value ===
                          periodSetting["collaborators"]["supervisor"]["id"]
                      )
                    }
                    // onChange={event =>
                    //   this.handleCollaboratorChange(event, zone, false, null)
                    // }
                    isDisabled={activatedLevel !== "LEVEL_3" || synchroRole}
                    className={styles.filter_frame_field_placeholder}
                  />
                </div>
                <div
                  className={styles2.select_dev}
                  style={{ margin: 0, marginBottom: 7, flex: "0 0 32%" }}
                >
                  <span>{_("GD")} </span>
                  <Select
                    isMulti={false}
                    isSearchable={false}
                    isClearable={false}
                    closeMenuOnSelect
                    placeholder={"Collaborator"}
                    options={
                      activatedLevel === "LEVEL_3"
                        ? this.renderCustomCollaborators()
                        : []
                    }
                    value={
                      collaboratorOptions.length > 0 &&
                      periodSetting["collaborators"]["gd"] &&
                      collaboratorOptions.find(
                        obj =>
                          obj.value ===
                          periodSetting["collaborators"]["gd"]["id"]
                      )
                    }
                    // onChange={event =>
                    //   this.handleCollaboratorChange(event, zone, false, null)
                    // }
                    isDisabled={activatedLevel !== "LEVEL_3" || synchroRole}
                    className={styles.filter_frame_field_placeholder}
                  />
                </div>
                <div
                  className={styles2.select_dev}
                  style={{ margin: 0, marginBottom: 7, flex: "0 0 32%" }}
                >
                  <span>{_("SCAN_OP")} </span>
                  <Select
                    isMulti={false}
                    isSearchable={false}
                    isClearable={false}
                    closeMenuOnSelect
                    placeholder={"Collaborator"}
                    options={
                      activatedLevel === "LEVEL_3"
                        ? this.renderCustomCollaborators()
                        : []
                    }
                    value={
                      collaboratorOptions.length > 0 &&
                      periodSetting["collaborators"]["scanOp"] &&
                      collaboratorOptions.find(
                        obj =>
                          obj.value ===
                          periodSetting["collaborators"]["scanOp"]["id"]
                      )
                    }
                    // onChange={event =>
                    //   this.handleCollaboratorChange(event, zone, false, null)
                    // }
                    isDisabled={activatedLevel !== "LEVEL_3" || synchroRole}
                    className={styles.filter_frame_field_placeholder}
                  />
                </div>
                <div
                  className={styles2.select_dev}
                  style={{ margin: 0, marginTop: 7, flex: "0 0 32%" }}
                >
                  <span>{_("se")}</span>
                  <Select
                    isMulti={false}
                    isSearchable={false}
                    isClearable={false}
                    closeMenuOnSelect
                    placeholder={"Collaborator"}
                    options={
                      activatedLevel === "LEVEL_3"
                        ? this.renderCustomCollaborators()
                        : []
                    }
                    value={
                      collaboratorOptions.length > 0 &&
                      periodSetting["collaborators"]["se"] &&
                      collaboratorOptions.find(
                        obj =>
                          obj.value ===
                          periodSetting["collaborators"]["se"]["id"]
                      )
                    }
                    // onChange={event =>
                    //   this.handleCollaboratorChange(event, zone, false, null)
                    // }
                    isDisabled={activatedLevel !== "LEVEL_3" || synchroRole}
                    className={styles.filter_frame_field_placeholder}
                  />
                </div>
                <div
                  className={styles2.select_dev}
                  style={{ margin: 0, marginTop: 7, flex: "0 0 32%" }}
                >
                  <span>{_("GE")} </span>
                  <Select
                    isMulti={false}
                    isSearchable={false}
                    isClearable={false}
                    closeMenuOnSelect
                    placeholder={"Collaborator"}
                    options={
                      activatedLevel === "LEVEL_3"
                        ? this.renderCustomCollaborators()
                        : []
                    }
                    value={
                      collaboratorOptions.length > 0 &&
                      periodSetting["collaborators"]["ge"] &&
                      collaboratorOptions.find(
                        obj =>
                          obj.value ===
                          periodSetting["collaborators"]["ge"]["id"]
                      )
                    }
                    // onChange={event =>
                    //   this.handleCollaboratorChange(event, zone, false, null)
                    // }
                    isDisabled={activatedLevel !== "LEVEL_3" || synchroRole}
                    className={styles.filter_frame_field_placeholder}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  backgroundColor: "rgb(232, 232, 232)",
                  height: "0.9px",
                  marginTop: "2em",
                  marginBottom: "2em"
                }}
              />
              {alerts.level3 && (
                <div className={styles.alert_container}>
                  <Alert
                    message={alerts.level3.comment}
                    type="error"
                    showIcon
                  />
                </div>
              )}

              <div className={styles.budget_left}>
                <span>{_("globalBudgetLeft")} :</span>
                <span>{exceededBudgetRate.toFixed(2)}</span>
              </div>

              <div style={{ width: "100%" }}>
                {selectedZones &&
                  selectedZones.length > 0 &&
                  selectedZones.map((zone, index) => (
                    <div
                      className={styles.zone_budget}
                      style={{
                        marginBottom:
                          selectedZones.length !== index + 1 ? "1em" : ""
                      }}
                    >
                      <div>
                        <span>
                          <p>{zone["label"]} : </p>
                        </span>
                        <span>
                          <p>Total budget : </p>
                          <p>
                            <NumberFormat
                              value={zone["total"]["total"]}
                              displayType={"text"}
                              decimalScale={2}
                              decimalSeparator={","}
                              thousandSeparator={"."}
                            />
                          </p>
                        </span>
                      </div>
                      <div>
                        {zone["responsibles"] &&
                          Object.keys(zone["responsibles"])
                            .sort((a, b) => a.localeCompare(b))
                            .map(key => (
                              <div className={styles.line}>
                                <div>
                                  <div
                                    className={styles.item_body_level_1_line}
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      padding: "5px 0 5px"
                                    }}
                                  >
                                    {
                                      <div
                                        className={styles.switch_frame}
                                        style={{ marginLeft: 0 }}
                                      >
                                        <Tooltip
                                          key={`delegation-${key}`}
                                          placement="top"
                                          title={
                                            zone["responsibles"][key][
                                              "isActive"
                                            ]
                                              ? _("desactivate")
                                              : _("activate")
                                          }
                                        >
                                          <Switch
                                            disabled={
                                              activatedLevel !== "LEVEL_3"
                                            }
                                            checked={
                                              zone["responsibles"][key][
                                                "isActive"
                                              ]
                                            }
                                            onChange={() =>
                                              this.handleToggleZoneDelegation(
                                                zone,
                                                key
                                              )
                                            }
                                          />
                                        </Tooltip>
                                      </div>
                                    }
                                    <hr className={styles.hr} />
                                    <label
                                      style={{
                                        minWidth: 90,
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        paddingTop: 13
                                      }}
                                    >
                                      {_(zone["responsibles"][key]["role"])} :
                                    </label>
                                    <div
                                      className={styles.select_frame}
                                      style={{ margin: "0px 10px" }}
                                    >
                                      {collaboratorOptions && (
                                        <Select
                                          isMulti={false}
                                          isSearchable={false}
                                          isClearable={false}
                                          closeMenuOnSelect
                                          placeholder={"collaborator"}
                                          options={
                                            activatedLevel === "LEVEL_3"
                                              ? collaboratorOptions
                                              : []
                                          }
                                          value={collaboratorOptions.find(
                                            obj =>
                                              obj.value ===
                                              zone["responsibles"][key]["id"]
                                          )}
                                          // onChange={event =>
                                          //   this.handleChangeSupervisor(event)
                                          // }
                                          isDisabled={true}
                                          className={
                                            styles.filter_frame_field_placeholder
                                          }
                                        />
                                      )}

                                      <div
                                        style={{
                                          fontWeight: "normal",
                                          fontSize: "12px",
                                          display: "flex",
                                          margin: "5px 0px 5px 5px"
                                        }}
                                      >
                                        <span
                                          className={styles.select_frame_span}
                                        >
                                          {collaboratorOptions &&
                                          collaboratorOptions.length > 0 &&
                                          collaboratorOptions.find(
                                            obj =>
                                              obj.value ===
                                              zone["responsibles"][key]["id"]
                                          ) ? (
                                            <NumberFormat
                                              value={
                                                collaboratorOptions.find(
                                                  obj =>
                                                    obj["value"] ===
                                                    zone["responsibles"][key][
                                                      "id"
                                                    ]
                                                )["budget"]
                                              }
                                              displayType={"text"}
                                              decimalScale={2}
                                              decimalSeparator={","}
                                              thousandSeparator={"."}
                                            />
                                          ) : (
                                            0
                                          )}
                                        </span>
                                        {_("AnnualAffectedBudget")}
                                      </div>
                                    </div>
                                    <div className={styles.input_frame}>
                                      <input
                                        type="number"
                                        style={{ margin: 0, width: 77 }}
                                        value={
                                          zone["responsibles"][key]["base"]
                                        }
                                        onChange={event =>
                                          this.handleChangeBudgetZone(
                                            event,
                                            zone,
                                            [key]
                                          )
                                        }
                                        onBlur={event =>
                                          this.handleChangeBudgetZone(
                                            event,
                                            zone,
                                            [key],
                                            true
                                          )
                                        }
                                        disabled={
                                          activatedLevel !== "LEVEL_3" ||
                                          !zone["responsibles"][key]["isActive"]
                                        }
                                      />
                                    </div>
                                    {/*-------------- Delegated Collaborators--------------*/}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 10,
                                        marginLeft: 9,
                                        marginBottom: 10
                                      }}
                                    >
                                      {zone["responsibles"][key][
                                        "delegatedCollaborators"
                                      ].map((item, index) => {
                                        return (
                                          <div
                                            key={index}
                                            className={styles.sub_line}
                                          >
                                            <div
                                              className={styles.select_frame}
                                            >
                                              <Select
                                                isMulti={false}
                                                isSearchable={false}
                                                isClearable={false}
                                                closeMenuOnSelect
                                                placeholder={"collaborator"}
                                                options={
                                                  activatedLevel === "LEVEL_3"
                                                    ? this.renderCollaboratorOptions(
                                                        zone,
                                                        key
                                                      )
                                                    : []
                                                }
                                                value={
                                                  collaboratorOptions.length >
                                                    0 &&
                                                  item["id"] &&
                                                  collaboratorOptions.find(
                                                    obj =>
                                                      obj.value === item["id"]
                                                  )
                                                }
                                                isDisabled={
                                                  activatedLevel !==
                                                    "LEVEL_3" ||
                                                  !zone["responsibles"][key][
                                                    "isActive"
                                                  ]
                                                  // || this.props.parameterSettings.synchroRole
                                                }
                                                onChange={event =>
                                                  this.handleCollaboratorChange(
                                                    event,
                                                    zone,
                                                    // true,
                                                    [key, index]
                                                  )
                                                }
                                                className={
                                                  styles.filter_frame_field_placeholder
                                                }
                                              />
                                              {collaboratorOptions.find(
                                                obj => obj.value === item["id"]
                                              ) && (
                                                <div
                                                  style={{
                                                    fontWeight: "normal",
                                                    fontSize: "12px",
                                                    display: "flex",
                                                    margin: "5px 0px 5px 5px"
                                                  }}
                                                >
                                                  <span
                                                    className={
                                                      styles.select_frame_span
                                                    }
                                                  >
                                                    {collaboratorOptions &&
                                                      collaboratorOptions.find(
                                                        obj =>
                                                          obj.value ===
                                                          item["id"]
                                                      ) && (
                                                        <NumberFormat
                                                          value={
                                                            collaboratorOptions.find(
                                                              obj =>
                                                                obj["value"] ===
                                                                item["id"]
                                                            )["budget"]
                                                          }
                                                          displayType={"text"}
                                                          decimalScale={2}
                                                          decimalSeparator={","}
                                                          thousandSeparator={
                                                            "."
                                                          }
                                                        />
                                                      )}
                                                  </span>
                                                  {_("AnnualAffectedBudget")}
                                                </div>
                                              )}
                                            </div>
                                            <div className={styles.input_frame}>
                                              <input
                                                type="number"
                                                value={item["base"]}
                                                onChange={event =>
                                                  this.handleChangeBudgetZone(
                                                    event,
                                                    zone,
                                                    [key, index]
                                                  )
                                                }
                                                onBlur={input =>
                                                  this.handleChangeBudgetZone(
                                                    input,
                                                    zone,
                                                    [key, index],
                                                    true
                                                  )
                                                }
                                                disabled={
                                                  activatedLevel !==
                                                    "LEVEL_3" ||
                                                  !zone["responsibles"][key][
                                                    "isActive"
                                                  ]
                                                }
                                              />
                                            </div>
                                            <Button
                                              style={{
                                                height: 38,
                                                width: 38,
                                                background: "#F8F9FA",
                                                lineHeight: "16px",
                                                borderRadius: "4px",
                                                boxSizing: "border-box",
                                                border: "1px solid #B2BCC6",
                                                padding: "0px",
                                                boxShadow:
                                                  "0px 2px 5px rgba(0, 0, 0, 0.2)"
                                              }}
                                              disabled={
                                                activatedLevel !== "LEVEL_3" ||
                                                !zone["responsibles"][key][
                                                  "isActive"
                                                ]
                                                // || this.props.parameterSettings.synchroRole
                                              }
                                              onClick={() =>
                                                this.handleRemoveDelegatedCollaborator(
                                                  zone,
                                                  [key, index]
                                                )
                                              }
                                            >
                                              <Garbage />
                                            </Button>
                                          </div>
                                        );
                                      })}
                                      {zone["responsibles"][key][
                                        "isActive"
                                      ] && (
                                        <div className={styles.sub_line}>
                                          <Button
                                            style={{
                                              height: 38,
                                              width: 38,
                                              margin: "0px 10px",
                                              background: "#F8F9FA",
                                              lineHeight: "16px",
                                              borderRadius: "4px",
                                              boxSizing: "border-box",
                                              border: "1px solid #B2BCC6",
                                              padding: "0px",
                                              filter:
                                                "drop-shadow(0px 4px 4px rgba(41, 57, 77, 0.1))"
                                            }}
                                            disabled={
                                              this.renderAddDelegatedCollaboratorState(
                                                zone
                                              )
                                              // || this.props.parameterSettings.synchroRole
                                            }
                                            onClick={() =>
                                              this.handleAddDelegatedCollaborator(
                                                zone,
                                                key
                                              )
                                            }
                                          >
                                            <PlusIcon />
                                          </Button>
                                          <label>{_("addNewDelegated")}</label>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {this.renderBudgetLevelFooter("LEVEL_3")}
        </div>
        {/* <div id="level4" key="level_4" className={styles.item}>
          <div
            className={styles.item_body}
            onClick={() => this.changeActivatedLevel("LEVEL_4")}
          >
            <div
              className={`${styles.item_body_level} ${
                styles.item_body_level_4
              } ${
                // levelStates.level4.includes(STATES.VALID)
                activatedLevel === "LEVEL_4" ? styles.valid : styles.unvalid
              }
              ${
                activatedLevel === "LEVEL_4" ? styles.unlocked : styles.locked
              }`}
            >
              <div className={classnames(styles.component1, styles.component4)}>
                <div
                  className={`${
                    currentState === "LEVEL_4" && activatedLevel !== "LEVEL_4"
                      ? classnames(styles.cercleInitial, styles.cercleDisable)
                      : activatedLevel === "LEVEL_4"
                        ? classnames(styles.cercleInitial, styles.cercleEnable)
                        : activatedLevel === "LEVEL_1" ||
                          activatedLevel === "LEVEL_2" ||
                          activatedLevel === "LEVEL_3"
                          ? styles.cercleInitial
                          : classnames(
                              styles.cercleInitial,
                              styles.cercleDisable
                            )
                  }`}
                  onClick={() => this.changeActivatedLevel("LEVEL_4")}
                />
                <span
                  className={classnames(styles.ligneInitial, styles.ligne4)}
                />
                <p
                  className={`${
                    currentState === "LEVEL_4" && activatedLevel !== "LEVEL_4"
                      ? styles.budget_state_title
                      : activatedLevel === "LEVEL_1" ||
                        activatedLevel === "LEVEL_2" ||
                        activatedLevel === "LEVEL_3"
                        ? styles.budget_state_title_initial
                        : styles.budget_state_title
                  } `}
                  onClick={() => this.changeActivatedLevel("LEVEL_4")}
                >
                  {_("attributionBudgetaire")}
                </p>
                <span
                  className={styles.budget_state_sous_titre}
                  style={{ fontSize: 12 }}
                >
                  {status4}
                </span>
              </div>
              {selectedZones && selectedZones.length > 0 ? (
                <Fragment>
                  {warnings.level4 && (
                    <div
                      style={{
                        fontWeight: "normal",
                        fontSize: "12px",
                        display: "flex",
                        margin: "5px 0px 5px 5px"
                      }}
                    >
                      <span className={styles.item_body_level_1_warning}>
                        <TiWarningOutline />
                      </span>
                      {_(warnings.level4.comment)}
                    </div>
                  )}
                  <table>
                    <thead>
                      <tr>
                        <th>{_("categories")}</th>
                        <th>
                          <div
                            style={{
                              width: 110,
                              display: "flex",
                              justifyContent: "end"
                            }}
                          >
                            <div className={styles.th_span_frame}>
                              <div>{_("solde")}</div>
                              <div style={{ marginTop: "10px" }}>
                                <div className={styles.details}>
                                  <div className={styles.details_years}>
                                    <span
                                      className={styles.span_1}
                                      style={{ backgroundColor: "moccasin" }}
                                    >
                                      {budget &&
                                      budget.totals &&
                                      budget.totals.actualYearBudget
                                        ? getFormatNumber(categoriesBudgetLeft)
                                        : 0}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.th_span_frame}>
                              <div>{_("total")}</div>
                              <div style={{ marginTop: "10px" }}>
                                <span className={styles.span_1}>
                                  {budget
                                    ? getFormatNumber(
                                        budget.totals.actualYearBudget
                                      )
                                    : 0}
                                </span>
                              </div>
                            </div>
                          </div>
                        </th>
                        {selectedZones &&
                          selectedZones.map(item => {
                            return (
                              <th key={`th-${item.id}`}>
                                <div className={styles.th_spans_frame}>
                                  <div>{item.label}</div>

                                  <div className={styles.details}>
                                    <div className={styles.details_years}>
                                      <div className={styles.details_text}>
                                        Budget {year}
                                      </div>
                                      <span className={styles.span_1}>
                                        {getFormatNumber(
                                          item.total.totalCategories
                                        )}
                                        /{item &&
                                          item.total &&
                                          getFormatNumber(
                                            this.getTotalZone(item)
                                          )}
                                      </span>
                                    </div>

                                    <div className={styles.details_years}>
                                      <div className={styles.details_text}>
                                        Budget {year - 1}
                                      </div>
                                      <span className={styles.span_2}>
                                        {item &&
                                          item.total &&
                                          getFormatNumber(
                                            item.total.totalLastYear
                                          )}
                                      </span>
                                    </div>

                                    <div className={styles.details_years}>
                                      <div className={styles.details_text}>
                                        {_("realized")}
                                        <br />
                                        {year - 1}
                                      </div>
                                      <span className={styles.span_3}>
                                        {item &&
                                          item.total &&
                                          getFormatNumber(
                                            item.total.totalRealTime
                                          )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody>
                      {categories.map((category, i) => {
                        return (
                          <tr key={`category-${i}`}>
                            <td>{category.label.fr}</td>
                            <td>
                              <div
                                className={`${styles.indice_frame} ${
                                  styles.indice_frame_2
                                }`}
                              >
                                {selectedCategories.length > 0 &&
                                selectedCategories.find(
                                  obj => obj.id === category.id
                                ) &&
                                getBudgetNumberLabelFormat(
                                  parseFloat(
                                    selectedCategories.find(
                                      obj => obj.id === category.id
                                    ).total
                                  )
                                )
                                  ? getBudgetNumberLabelFormat(
                                      parseFloat(
                                        selectedCategories.find(
                                          obj => obj.id === category.id
                                        ).total &&
                                          selectedCategories.find(
                                            obj => obj.id === category.id
                                          ).total
                                      )
                                    )
                                  : ""}
                              </div>
                            </td>
                            {selectedZones &&
                              selectedZones.map(zone => {
                                return (
                                  <td key={`td-${category.id}-${zone.id}`}>
                                    <div className={styles.input_frame}>
                                      <input
                                        type="number"
                                        value={
                                          selectedCategories.find(
                                            obj => obj.id === category.id
                                          ) &&
                                          selectedCategories.find(
                                            obj => obj.id === category.id
                                          ).zones &&
                                          selectedCategories
                                            .find(obj => obj.id === category.id)
                                            .zones.find(
                                              obj => obj.zone === zone.id
                                            ) &&
                                          selectedCategories
                                            .find(obj => obj.id === category.id)
                                            .zones.find(
                                              obj => obj.zone === zone.id
                                            ).bases.actualYear
                                            ? selectedCategories
                                                .find(
                                                  obj => obj.id === category.id
                                                )
                                                .zones.find(
                                                  obj => obj.zone === zone.id
                                                ).bases.actualYear
                                            : ""
                                        }
                                        onChange={input =>
                                          this.handleChangeBudgetByCategory(
                                            category,
                                            zone,
                                            input
                                          )
                                        }
                                        onBlur={input =>
                                          this.handleChangeBudgetByCategory(
                                            category,
                                            zone,
                                            input,
                                            true
                                          )
                                        }
                                        disabled={activatedLevel !== "LEVEL_4"}
                                        required={true}
                                        style={{ minWidth: 80 }}
                                      />
                                    </div>
                                    <span className={styles.span_0}>
                                      {selectedCategories.find(
                                        obj => obj.id === category.id
                                      ) &&
                                      selectedCategories.find(
                                        obj => obj.id === category.id
                                      ).zones &&
                                      selectedCategories
                                        .find(obj => obj.id === category.id)
                                        .zones.find(
                                          obj => obj.zone === zone.id
                                        ) &&
                                      selectedCategories
                                        .find(obj => obj.id === category.id)
                                        .zones.find(obj => obj.zone === zone.id)
                                        .bases &&
                                      selectedCategories
                                        .find(obj => obj.id === category.id)
                                        .zones.find(obj => obj.zone === zone.id)
                                        .bases.lastYear
                                        ? parseFloat(
                                            selectedCategories
                                              .find(
                                                obj => obj.id === category.id
                                              )
                                              .zones.find(
                                                obj => obj.zone === zone.id
                                              ).bases.lastYear
                                          ).toFixed(2)
                                        : "-"}
                                    </span>
                                    <span className={styles.span_0}>
                                      {selectedCategories.find(
                                        obj => obj.id === category.id
                                      ) &&
                                      selectedCategories.find(
                                        obj => obj.id === category.id
                                      ).zones &&
                                      selectedCategories
                                        .find(obj => obj.id === category.id)
                                        .zones.find(
                                          obj => obj.zone === zone.id
                                        ) &&
                                      selectedCategories
                                        .find(obj => obj.id === category.id)
                                        .zones.find(obj => obj.zone === zone.id)
                                        .bases.realTime
                                        ? parseFloat(
                                            selectedCategories
                                              .find(
                                                obj => obj.id === category.id
                                              )
                                              .zones.find(
                                                obj => obj.zone === zone.id
                                              ).bases.realTime
                                          ).toFixed(2)
                                        : "-"}
                                    </span>
                                  </td>
                                );
                              })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Fragment>
              ) : (
                <div className={styles.infos_frame}>
                  <img src={"/img/icons/info.svg"} alt="" />
                  <label>{_("validatePreviousLevels")}</label>
                </div>
              )}
            </div>
          </div>
          {this.renderBudgetLevelFooter("LEVEL_4")}
        </div> */}
      </div>
    );
  };

  renderBudgetSettingCallout = code => {
    const { year } = this.state;
    switch (code) {
      case 170148:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={
              _("noAnnualCalendar") +
              " " +
              year +
              " " +
              _("annualCalendarNotConfig")
            }
            buttonIgnored={this.props.embedded}
          />
        );
      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={this.props.embedded}
          />
        );
    }
  };

  renderBudgetLevelFooter = id => {
    let {
      modifiedLevel,
      activatedLevel,
      exceededBudgetRate,
      selectedZoneIds,
      fetchingLevel
    } = this.state;

    return (
      activatedLevel === id && (
        <div
          className={styles.item_footer}
          style={{
            display: "flex",
            justifyContent: id === "LEVEL_1" ? "end" : "space-between"
          }}
        >
          {id !== "LEVEL_1" && (
            <div>
              <Button
                style={{
                  height: 40,
                  width: 124,
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "rgb(109, 127, 146, 0.8)",
                  lineHeight: "16px",
                  borderRadius: "5px",
                  fontStyle: "normal",
                  fontFamily: "Roboto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  boxSizing: "border-box",
                  textTransform: "uppercase",
                  border: "1px solid rgba(109, 127, 146, 0.5)"
                }}
                onClick={() => this.handlePreviousLevel(id)}
              >
                {_("previous")}
                <DoubleArrowUp />
              </Button>
            </div>
          )}
          <div style={{ display: "flex" }}>
            {modifiedLevel === id && (
              <Button
                style={{
                  height: 40,
                  width: 40,
                  border: "none",
                  padding: "11px",
                  color: "#FFFFFF",
                  marginRight: "10px",
                  borderRadius: "5px",
                  background: "#F1F2F4",
                  boxSizing: "border-box",
                  boxShadow: "0px 2px 10px rgba(41, 57, 77, 0.1)"
                }}
                onClick={this.resetBudgetState}
              >
                <ResetIcon />
              </Button>
            )}
            {this.renderValidatedLevelState(id, STATES.VALID) &&
            id !== "LEVEL_3" ? (
              modifiedLevel === id ? (
                <Button
                  style={{
                    width: 124,
                    height: 40,
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    fontWeight: 500,
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontFamily: "Roboto",
                    lineHeight: "16px",
                    textTransform: "uppercase",
                    color: "#FFFFFF",
                    // background: "#18A0FB",
                    boxSizing: "border-box",
                    boxShadow: "0px 2px 10px rgba(41, 57, 77, 0.1)",
                    backgroundColor: "#06d9b1",
                    border: "1px solid #62deb0",
                    borderRadius: "5px",
                    opacity:
                      this.renderClickValidateLevelState(id) ||
                      (selectedZoneIds && selectedZoneIds.length === 0) ||
                      exceededBudgetRate < 0
                        ? 0.4
                        : 1
                  }}
                  disabled={
                    this.renderClickValidateLevelState(id) ||
                    (selectedZoneIds && selectedZoneIds.length === 0) ||
                    exceededBudgetRate < 0
                  }
                  onClick={() => this.handleCheckSaveLevel(id)}
                  loading={fetchingLevel}
                >
                  {_("validate")}
                  <CheckMarkIcon fill={"white"} />
                </Button>
              ) : (
                <Button
                  style={{
                    height: 40,
                    width: 124,
                    border: "none",
                    fontWeight: 500,
                    fontSize: "14px",
                    color: "#FFFFFF",
                    lineHeight: "16px",
                    fontStyle: "normal",
                    borderRadius: "5px",
                    fontFamily: "Roboto",
                    background: "#18A0FB",
                    boxSizing: "border-box",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    textTransform: "uppercase",
                    boxShadow: "0px 2px 10px rgba(41, 57, 77, 0.1)",
                    opacity: this.renderClickNextLevelState(id) ? 0.4 : 1
                  }}
                  disabled={this.renderClickNextLevelState(id)}
                  onClick={() => this.handleNextLevel(id)}
                >
                  {_("next")}
                  <DoubleArrowUp className={styles.rotate180} fill="white" />
                </Button>
              )
            ) : (
              <div style={{ display: "flex" }}>
                <Button
                  style={{
                    width: 124,
                    height: 40,
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    fontWeight: 500,
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontFamily: "Roboto",
                    lineHeight: "16px",
                    textTransform: "uppercase",
                    color: "#FFFFFF",
                    boxSizing: "border-box",
                    boxShadow: "0px 2px 10px rgba(41, 57, 77, 0.1)",
                    backgroundColor: "#06d9b1",
                    border: "1px solid #62deb0",
                    borderRadius: "5px",
                    opacity:
                      modifiedLevel !== id || exceededBudgetRate < 0 ? 0.4 : 1
                  }}
                  disabled={
                    modifiedLevel !== id || exceededBudgetRate < 0 //To remoeve exceededBudget later on
                  }
                  onClick={() => this.handleCheckSaveLevel(id)}
                  loading={fetchingLevel}
                >
                  {_("validate")}
                  <CheckMarkIcon fill={"white"} />
                </Button>
              </div>
            )}
          </div>
        </div>
      )
    );
  };

  renderValidatedLevelState = (id, state) => {
    let { levelStates } = this.state;
    switch (id) {
      case "LEVEL_1":
        return levelStates.level1.includes(state);

      case "LEVEL_2":
        return levelStates.level2.includes(state);

      case "LEVEL_3":
        return levelStates.level3.includes(state);

      case "LEVEL_4":
        return levelStates.level4.includes(state);
      default:
        return;
    }
  };

  renderCollaboratorOptions = (zone, roleKey) => {
    const { collaboratorOptions } = this.state;

    const { responsibles } = zone;
    let collaboratorIds = [];

    Object.keys(responsibles).forEach(key => {
      const item = responsibles[key];
      if (item["id"]) {
        collaboratorIds.push(item["id"]);
        if (item["delegatedCollaborators"]) {
          const delegateds = item["delegatedCollaborators"]
            .filter(item2 => item2["id"])
            .map(item2 => item2["id"]);
          collaboratorIds.push({ ...delegateds });
        }
      }
    });
    const collaborators = collaboratorOptions.filter(
      item =>
        !collaboratorIds.includes(item["value"]) && item["zone"] === zone["id"]
    );
    return collaborators;
  };

  renderCustomCollaborators = () => {
    let { collaboratorOptions } = this.state;

    return collaboratorOptions.filter(item => item.zone === 1);
  };

  checkZonesBudgetState = (callback = null) => {
    const {
      budget: {
        totals: { actualYearBudget, totalAchievedBudget }
      }
    } = this.state;
    let warning = null;

    const result = actualYearBudget - totalAchievedBudget;
    if (result < 0)
      warning = { isVisible: true, comment: _("surpassedBudget") };

    this.setState(
      {
        exceededBudgetRate: result,
        warnings: { ...this.state.warnings, level1: warning }
      },
      () => callback && callback()
    );
  };

  //*************   Action functionsn  *******************//
  //*************   Level 1  *************//
  handleChangeBudgetHoursTotal = (event, format = false) => {
    const { value } = event.target;
    const { actualYearBudget } = this.props.budgetData.totals;
    if (value < 0 || toNumber(actualYearBudget) === toNumber(value)) {
      this.setState({ modifiedLevel: null, budget: this.props.budgetData });
      return;
    }
    // TODO change by total deleations
    this.setState({
      budget: {
        ...this.state.budget,
        totals: {
          ...this.state.budget.totals,
          actualYearBudget: !format ? value : Number(value).toFixed(2)
        }
      },
      modifiedLevel: "LEVEL_1"
    });
  };

  handleChangeEconomicBudget = (event, format = false) => {
    const { value } = event.target;
    const { actualYearEconomicBudget } = this.props.budgetData.totals;
    if (value < 0 || toNumber(actualYearEconomicBudget) === toNumber(value)) {
      this.setState({ modifiedLevel: null, budget: this.props.budgetData });
      return;
    }
    this.setState({
      budget: {
        ...this.state.budget,
        totals: {
          ...this.state.budget.totals,
          actualYearEconomicBudget: !format ? value : Number(value).toFixed(2)
        }
      },
      modifiedLevel: "LEVEL_1"
    });
  };

  handleChangeSupervisor = event => {
    const { id, value } = this.state.budget.supervisor;
    const collaboratorOptions = this.recalculateCollaboratorBudget({
      oldId: id,
      newId: event.value,
      base: value
    });
    this.setState({
      collaboratorOptions,
      budget: {
        ...this.state.budget,
        supervisor: {
          ...this.state.budget.supervisor,
          id: event.value,
          name: event.label
        }
      },
      modifiedLevel: "LEVEL_1"
    });
  };

  handleChangeSupervisorBudget = (event, format = false) => {
    const { value } = event.target;
    if (value < 0 || Number.isNaN(value)) {
      return;
    }
    let {
      budget: { supervisor },
      collaboratorOptions
    } = this.state;
    if (!format && supervisor.id) {
      const base = parseFloat(value !== "" ? value : "0") - supervisor.value;
      collaboratorOptions = collaboratorOptions.map(
        item =>
          item.value === supervisor.id
            ? {
                ...item,
                budget: parseFloat(item.budget) + base
              }
            : item
      );
    }

    this.setState({
      collaboratorOptions,
      budget: {
        ...this.state.budget,
        supervisor: {
          ...supervisor,
          value: !format ? value : Number(value).toFixed(2)
        }
      },
      modifiedLevel: "LEVEL_1"
    });
  };

  //*************   Level 2  *************//
  handleSelectZone = id => {
    let { selectedZoneIds, selectedZones, warnings } = this.state;
    let warning = warnings.level2;

    let newSelectedItems = [...selectedZoneIds];
    if (newSelectedItems.includes(id)) {
      newSelectedItems.splice(newSelectedItems.indexOf(id), 1);
      selectedZones.forEach(item => {
        if (id === item.id && item.total.totalActualYear > 0) {
          warning = { isVisible: true, comment: _("overwrittenZoneBudget") };
        }
      });
    } else {
      newSelectedItems.push(id);
      selectedZones.forEach(item => {
        if (id === item.id && item.total.totalActualYear > 0) {
          warning = null;
        }
      });
    }
    this.setState({
      ...this.state,
      modifiedLevel: "LEVEL_2",
      selectedZoneIds: newSelectedItems,
      warnings: { ...this.state.warnings, level2: warning }
    });
  };

  //*************   Level 3  *************//
  handleChangeBudgetZone = (event, zoneParam, params, format = false) => {
    let {
      collaboratorOptions,
      selectedZones,
      budget: {
        totals: { actualYearBudget }
      }
    } = this.state;
    // const {
    //   budgetData: { zones }
    // } = this.props;

    const inputValue = event.target.value ? parseFloat(event.target.value) : 0;

    if (inputValue < 0) {
      return;
    }

    let alerts = null;

    let budgetDiff = inputValue;
    let selectedCollaborator;

    // Synchronize collaborator annual affected budget
    if (params.length === 1) {
      selectedCollaborator = zoneParam["responsibles"][params[0]];
      budgetDiff -= selectedCollaborator["base"];
      collaboratorOptions = collaboratorOptions.map(
        item =>
          item.value === selectedCollaborator["id"]
            ? { ...item, budget: item.budget + budgetDiff }
            : item
      );
    } else {
      const selectedResponsible = zoneParam["responsibles"][params[0]];

      selectedCollaborator =
        selectedResponsible["delegatedCollaborators"][params[1]];
      budgetDiff -= selectedCollaborator["base"];

      collaboratorOptions = collaboratorOptions.map(item => {
        switch (item.value) {
          case selectedCollaborator["id"]:
            return { ...item, budget: item.budget + budgetDiff };

          case selectedResponsible["id"]:
            return { ...item, budget: item.budget - budgetDiff };

          default:
            return item;
        }
      });
    }

    // Update budgets for each zone
    let newZones = selectedZones.map(zone => {
      if (zone.id === zoneParam.id) {
        let newZone = null;
        const { responsibles } = zone;
        switch (params.length) {
          case 1:
            newZone = {
              ...zone,
              responsibles: {
                ...responsibles,
                [params[0]]: {
                  ...responsibles[params[0]],
                  base: !format ? inputValue : toFixed(inputValue, 2),
                  total: responsibles[params[0]]["total"] + budgetDiff
                }
              },
              total: {
                ...zone.total,
                total: zone["total"]["total"] + budgetDiff,
                totalActualYear: !format ? inputValue : inputValue.toFixed(2)
              }
            };
            break;
          case 2:
            const selectedResponsible = responsibles[params[0]];
            const delegated = selectedResponsible["delegatedCollaborators"].map(
              (item, index) =>
                index === params[1]
                  ? {
                      ...item,
                      base: !format ? inputValue : toFixed(inputValue, 2)
                    }
                  : item
            );
            newZone = {
              ...zone,
              responsibles: {
                ...responsibles,
                [params[0]]: {
                  ...selectedResponsible,
                  base: toFixed(selectedResponsible["base"] - budgetDiff, 2),
                  delegatedCollaborators: delegated
                }
              }
            };
            break;
          default:
            newZone = zone;
            break;
        }

        return newZone;
      }
      return zone;
    });

    //validate budget data
    let sum = 0;
    switch (params.length) {
      case 1:
        newZones.forEach(item => (sum += toNumber(item["total"]["total"])));
        sum = toFixed(sum, 2);
        if (actualYearBudget < sum) {
          alerts = { isVisible: true, comment: _("insufficientGlobalBudget") };
        }
        break;
      case 2:
        const responsibleBase = newZones.find(
          item => item["id"] === zoneParam["id"]
        )["responsibles"][params[0]]["base"];
        if (responsibleBase < 0) {
          alerts = {
            isVisible: true,
            comment: _("insufficientResponsibleBudget")
          };
          return;
        }
        break;
      default:
        break;
    }

    this.setState(
      {
        collaboratorOptions,
        selectedZones: newZones,
        modifiedLevel: "LEVEL_3",
        alerts: { ...this.state.alerts, level3: alerts },
        budget: {
          ...this.state.budget,
          totals: {
            ...this.state.budget.totals,
            totalAchievedBudget: toFixed(sum, 2)
          }
        }
      },
      () => {
        params.length === 1 && this.checkZonesBudgetState();
      }
    );
  };

  handleRecalculateAffectedBudgetZone = (
    collaboratorOptions,
    id,
    operation
  ) => {
    return collaboratorOptions.map(obj => {
      if (obj.value === parseInt(id, 10) && operation) {
        return {
          ...obj,
          budget: parseFloat(
            (operation.sign === "-"
              ? obj.budget - operation.value
              : obj.budget + operation.value
            ).toFixed(2)
          )
        };
      }
      return obj;
    });
  };

  handleCollaboratorChange = (event, zoneParam, params) => {
    let { selectedZones, collaboratorOptions } = this.state;
    const alert = !event.value
      ? {
          isRequired: true,
          comment: _("dataDelegatedCollaboratorRequired")
        }
      : null;
    let newZones = selectedZones.map(zone => {
      if (zone["id"] === zoneParam["id"]) {
        const { responsibles } = zone;
        if (params.length === 1) {
          // let principal = collaborators.principal
          //   ? { ...collaborators.principal, id: event.value }
          //   : { id: event.value, base: zone.total };
          // return {
          //   ...zone,
          //   collaborators: { ...zone.collaborators, principal: principal }
          // };
        } else if (params.length === 2) {
          const delegatedCollaborators = responsibles[params[0]][
            "delegatedCollaborators"
          ].map((collaborator, index2) => {
            if (index2 === params[1]) {
              return { ...collaborator, id: event.value, delegated: true };
            }
            return collaborator;
          });
          return {
            ...zone,
            responsibles: {
              ...zone["responsibles"],
              [params[0]]: {
                ...zone["responsibles"][params[0]],
                delegatedCollaborators
              }
            }
          };
        }
      }
      return zone;
    });
    this.verifyDelegatedCollaboratorValidity(newZones);

    if (params.length === 2) {
      const { id, base } = zoneParam["responsibles"][params[0]][
        "delegatedCollaborators"
      ][params[1]];
      collaboratorOptions = collaboratorOptions.map(
        item =>
          item.value === event.value
            ? { ...item, budget: item.budget + parseFloat(base) }
            : item.value === id
              ? { ...item, budget: item.budget - parseFloat(base) }
              : item
      );
    } else {
      const {
        responsibles: {
          [params[0]]: { id, base }
        }
      } = zoneParam;
      collaboratorOptions = this.recalculateCollaboratorBudget({
        oldId: id,
        newId: event.value,
        base: base
      });
    }

    this.setState({
      modifiedLevel: "LEVEL_3",
      selectedZones: newZones,
      collaboratorOptions,
      alerts: {
        ...this.state.alerts,
        level3: alert
      }
    });
  };

  recalculateCollaboratorBudget = ({ oldId, newId, base }) => {
    return this.state.collaboratorOptions.map(item => {
      return oldId === item.value
        ? {
            ...item,
            budget: parseFloat(item.budget) - parseFloat(base)
          }
        : newId === item.value
          ? {
              ...item,
              budget: parseFloat(item.budget) + parseFloat(base)
            }
          : item;
    });
  };

  handleToggleZoneDelegation = (item, roleKey) => {
    let {
      collaboratorOptions,
      selectedZones,
      budget,
      budget: { totals }
    } = this.state;
    let responsible;

    // const zones = selectedZones.map(zone => {
    //   if (
    //     zone["responsibles"][roleKey] &&
    //     ((item["id"] === zone["id"] &&
    //       !zone["responsibles"][roleKey]["delegation"]) ||
    //       (item["id"] !== zone["id"] &&
    //         zone["responsibles"][roleKey]["delegation"] &&
    //         zone["responsibles"][roleKey]["delegatedCollaborators"].length ===
    //           0))
    //   ) {
    //     alert = {
    //       isRequired: true,
    //       comment: _("dataDelegatedCollaboratorRequired")
    //     };
    //   }
    //   if (zone["id"] === item["id"]) {
    //     const { responsibles } = zone;
    //     responsible = responsibles[roleKey];
    //     return {
    //       ...zone,
    //       responsibles: {
    //         ...responsibles,
    //         [roleKey]: {
    //           ...responsible,
    //           base: responsible["total"],
    //           delegation: !responsible["delegation"],
    //           delegatedCollaborators: []
    //         }
    //       }
    //     };
    //   }
    //   return zone;
    // });

    // const delegatedCollaborators = Object.values(item["responsibles"]);
    // collaboratorOptions = collaboratorOptions = collaboratorOptions.map(
    //   item2 => {
    //     if (item2["value"] === responsible["id"])
    //       return {
    //         ...item2,
    //         budget:
    //           item2.budget +
    //           (toNumber(responsible["total"]) - toNumber(responsible["base"]))
    //       };

    //     let delegatedIndex = delegatedCollaborators.findIndex(
    //       element => element["id"] === item2["value"]
    //     );

    //     if (delegatedIndex !== -1) {
    //       const selectedDelegated = delegatedCollaborators[delegatedIndex];
    //       return {
    //         ...item2,
    //         budget: item2["budget"] - selectedDelegated["base"]
    //       };
    //     }
    //     return item2;
    //   }
    // );
    let newResponsibleBudget = 0;
    const zones = selectedZones.map(zone => {
      if (zone["id"] === item["id"]) {
        const { responsibles } = zone;
        responsible = responsibles[roleKey];
        newResponsibleBudget = responsible["isActive"]
          ? -responsible["total"]
          : responsible["total"];
        return {
          ...zone,
          responsibles: {
            ...responsibles,
            [roleKey]: {
              ...responsible,
              isActive: !responsible["isActive"]
            }
          },
          total: {
            ...zone["total"],
            total: zone["total"]["total"] + newResponsibleBudget
          }
        };
      }
      return zone;
    });

    this.setState(
      {
        ...this.state,
        collaboratorOptions: collaboratorOptions,
        selectedZones: zones,
        budget: {
          ...budget,
          totals: {
            ...totals,
            totalAchievedBudget:
              totals["totalAchievedBudget"] + newResponsibleBudget
          }
        },
        modifiedLevel: "LEVEL_3"
      },
      () => this.checkZonesBudgetState()
    );
  };

  handleOnBlurDelegatedBudget = (input, zoneParam, index) => {
    let { selectedZones } = this.state;
    let value = input.target.value ? input.target.value : 0;

    let newZones = selectedZones.map(zone => {
      if (zone.id === zoneParam.id) {
        let delegatedBudgets = zone.collaborators.delegated.map(
          (collaborator, index2) => {
            if (index2 === index) {
              return { ...collaborator, base: value };
            }
            return collaborator;
          }
        );
        return {
          ...zone,
          collaborators: {
            ...zone.collaborators,
            delegated: delegatedBudgets
          }
        };
      }
      return zone;
    });
    this.verifyDelegatedCollaboratorValidity(newZones);

    this.setState({
      selectedZones: newZones
    });
  };

  handleChangeDelegatedBudget = (input, zoneParam, index, format = false) => {
    let { selectedZones, collaboratorOptions } = this.state;
    let { value } = input.target;
    const alert =
      value < 0
        ? {
            isRequired: true,
            comment: _("dataDelegatedCollaboratorRequired")
          }
        : null;

    let { delegated, principal } = zoneParam.collaborators;
    let delegatedItem = delegated[index];
    const base = parseFloat(delegatedItem.base);
    const budget = parseFloat(principal.base) + base - toNumber(value);
    if (value < 0 || budget < 0) {
      this.setState({
        ...this.state,
        alerts: {
          ...this.state.alerts,
          level3: alert
        }
      });
      return;
    }

    let newZones = selectedZones.map(zone => {
      if (zone.id === zoneParam.id) {
        let delegateds = delegated.map((collaborator, index2) => {
          if (index2 === index) {
            value = toNumber(value);
            collaboratorOptions = this.handleRecalculateAffectedBudgetZone(
              collaboratorOptions,
              collaborator.id,
              value - collaborator.base > 0
                ? { sign: "+", value: value - collaborator.base }
                : { sign: "-", value: collaborator.base - value }
            );
            return {
              ...collaborator,
              base: !format ? value : value.toFixed(2)
            };
          }
          return collaborator;
        });

        collaboratorOptions = this.handleRecalculateAffectedBudgetZone(
          collaboratorOptions,
          principal.id,
          budget - principal.base > 0
            ? { sign: "+", value: budget - principal.base }
            : { sign: "-", value: principal.base - budget }
        );

        return {
          ...zone,
          collaborators: {
            ...zone.collaborators,
            principal: {
              ...zone.collaborators.principal,
              base: toNumber(budget).toFixed(2)
            },
            delegated: delegateds
          }
        };
      }
      return zone;
    });
    this.verifyDelegatedCollaboratorValidity(newZones);

    this.setState({
      collaboratorOptions,
      selectedZones: newZones,
      modifiedLevel: "LEVEL_3"
      // alerts: {
      //   ...this.state.alerts,
      //   level3: alert
      // }
    });
  };

  renderAddDelegatedCollaboratorState = zone => {
    let { activatedLevel } = this.state;
    let state = false;
    Object.keys(zone["responsibles"]).forEach(key => {
      const delegatedCollaborators =
        zone["responsibles"][key]["delegatedCollaborators"];
      delegatedCollaborators &&
        delegatedCollaborators.forEach(item => {
          if (item["base"] <= 0) {
            state = true;
          }
        });
    });
    return state || activatedLevel !== "LEVEL_3";
  };

  handleAddDelegatedCollaborator = (zoneParam, roleKey) => {
    const { selectedZones } = this.state;
    let zones = selectedZones.map(zone => {
      if (zone.id === zoneParam.id) {
        const responsibles = zone["responsibles"];
        return {
          ...zone,
          responsibles: {
            ...responsibles,
            [roleKey]: {
              ...responsibles[roleKey],
              delegatedCollaborators: [
                ...responsibles[roleKey]["delegatedCollaborators"],
                {
                  id: null,
                  responsible: responsibles[roleKey]["bzd_id"],
                  isActive: true,
                  base: 0
                }
              ]
            }
          }
        };
      }
      return zone;
    });

    this.setState({
      ...this.state,
      selectedZones: zones,
      modifiedLevel: "LEVEL_3",
      alerts: {
        ...this.state.alerts,
        level3: {
          isRequired: true,
          comment: _("dataDelegatedCollaboratorRequired")
        }
      }
    });
  };

  handleRemoveDelegatedCollaborator = (zoneParam, params) => {
    let { selectedZones, collaboratorOptions } = this.state;

    const delegated =
      zoneParam["responsibles"][params[0]]["delegatedCollaborators"][params[1]];

    //retrieve responsible
    const responsible = zoneParam["responsibles"][params[0]];

    collaboratorOptions = collaboratorOptions.map(item => {
      switch (item["value"]) {
        //remove budget from responsible
        case responsible["id"]:
          return {
            ...item,
            budget: toNumber(item["budget"]) + toNumber(delegated["base"])
          };
        //remove budget from delagated
        case delegated["id"]:
          return {
            ...item,
            budget: toNumber(item["budget"]) - toNumber(delegated["base"])
          };
        default:
          return item;
      }
    });

    let newZones = selectedZones.map(zone => {
      if (zone.id === zoneParam.id) {
        const { responsibles } = zone;
        const responsible = responsibles[params[0]];
        const delegatedCollaborators = responsible[
          "delegatedCollaborators"
        ].filter((_, index) => index !== params[1]);
        return {
          ...zone,
          responsibles: {
            ...responsibles,
            [params[0]]: {
              ...responsible,
              base: toNumber(responsible["base"]) + toNumber(delegated["base"]),
              delegatedCollaborators
            }
          }
        };
      }
      return zone;
    });

    let found = false;
    newZones.map(zone => {
      Object.keys(zone.responsibles).map(key => {
        zone.responsibles[key].delegatedCollaborators.map(delegated => {
          if (delegated.id === null) {
            found = true;
          }
        });
      });
    });

    if (!found) {
      this.setState({
        alerts: {
          ...this.state.alerts,
          level3: null
        }
      });
    }

    this.setState({
      collaboratorOptions,
      selectedZones: newZones,
      modifiedLevel: "LEVEL_3"
    });
  };

  recalculateCollaboratorAndDelegatedBudget = ({ id, delegatedId, total }) => {
    let { collaboratorOptions } = this.state;
    return collaboratorOptions.map(item => {
      if (id === item.value) {
        return { ...item, budget: item.budget + total };
      }
      if (delegatedId && delegatedId === item.value)
        return {
          ...item,
          budget: item.budget - total
        };
      return item;
    });
  };

  calculateDelegetedBudget = delegated => {
    return delegated && delegated.length > 0
      ? delegated.reduce(
          (accumulator, currentValue) =>
            accumulator + parseFloat(currentValue.base),
          0
        )
      : 0;
  };

  verifyDelegatedCollaboratorValidity = selectedZones => {
    let alert = null;

    selectedZones.forEach(item => {
      item.collaborators.delegated.forEach(collaborator => {
        if (parseFloat(collaborator.base) <= 0) {
          alert = {
            isRequired: true,
            comment: _("dataDelegatedCollaboratorRequired")
          };
        }
      });
    });
    this.setState({
      ...this.state,
      alerts: {
        ...this.state.alerts,
        level3: alert
      }
    });
  };
  //*************   Level 4  *************//
  handleOnBlurBudgetByCategory = (category, zoneParam, input) => {
    let { selectedCategories } = this.state;
    let value = input.target.value ? input.target.value : 0;
    let notFound = true;
    let newCategoriesValues = selectedCategories.map(item => {
      if (category.id === item.id) {
        let newZones = item.zones.map(zone => {
          if (zone.zone === zoneParam.id) {
            notFound = false;
            return {
              ...zone,
              bases: { ...zone.bases, actualYear: getBudgetNumberFormat(value) }
            };
          }
          return zone;
        });
        return { ...item, zones: newZones };
      }
      return item;
    });

    if (notFound && input.target.value !== null) {
      newCategoriesValues = selectedCategories.map(item => {
        if (category.id === item.id) {
          item.zones.push({
            id: category.id,
            bases: { actualYear: getBudgetNumberFormat(value) },
            zone: zoneParam.id
          });
        }
        return item;
      });
    }

    this.setState(
      {
        ...this.state,
        selectedCategories: newCategoriesValues
      },
      this.calculateTotalBudgets
    );
  };

  findSupervisorBudget = zone => {
    const { id, value } = this.state.budget.supervisor;
    const foundSupervisor = zone.collaboratorOptions.find(
      collaborator => collaborator.value === id
    );

    return foundSupervisor ? value : 0;
  };

  countZoneCategoriesBase = id => {
    const { selectedZones } = this.state;
    const zone = selectedZones.find(zone => zone.id === id);
    const base =
      zone.total.totalActualYear -
      zone.total.totalCategories +
      this.findSupervisorBudget(zone);
    return base;
  };

  getTotalZone = zone => {
    const supervisorBudget = this.findSupervisorBudget(zone);
    return (
      parseFloat(zone.total.totalActualYear) + parseFloat(supervisorBudget)
    );
  };

  handleChangeBudgetByCategory = (
    category,
    zoneParam,
    event,
    format = false
  ) => {
    let { totalCategoriesBudget, selectedCategories, budget } = this.state;
    let value = event.target.value ? event.target.value : 0;
    let warning = null;
    let base = 0;
    let zoneSolde = 0;

    if (value < 0 || Number.isNaN(value)) return;

    if (!format) {
      selectedCategories.forEach(item => {
        if (category.id === item.id) {
          item.zones.forEach(zone => {
            if (zone.zone === zoneParam.id) {
              base = parseFloat(zone.bases.actualYear || "0");
            }
          });
        }
      });
      zoneSolde = this.countZoneCategoriesBase(zoneParam.id);
      if (
        parseFloat(
          budget.totals.actualYearBudget - totalCategoriesBudget + base
        ).toFixed(2) < parseFloat(value) ||
        parseFloat(zoneSolde + base) < parseFloat(value)
      ) {
        return;
      }
    }

    let notFound = true;
    let newCategoriesValues = selectedCategories.map(item => {
      if (category.id === item.id) {
        let newZones = item.zones.map(zone => {
          if (zone.zone === zoneParam.id) {
            notFound = false;

            return {
              ...zone,
              bases: {
                ...zone.bases,
                actualYear: !format ? value : Number(value).toFixed(2)
              }
            };
          }
          return zone;
        });
        return { ...item, zones: newZones };
      }
      return item;
    });

    if (notFound && value !== null && !format) {
      newCategoriesValues = selectedCategories.map(item => {
        if (category.id === item.id) {
          item.zones.push({
            id: category.id,
            bases: { actualYear: parseFloat(value) },
            zone: zoneParam.id
          });
        }
        return item;
      });
    }

    this.setState(
      {
        ...this.state,
        modifiedLevel: "LEVEL_4",
        selectedCategories: newCategoriesValues,
        warnings: { ...this.state.warnings, level4: warning }
      },
      this.calculateTotalBudgets
    );
  };
  //à revoir d'où vient le probleme de zone null
  calculateTotalBudgets = () => {
    let { selectedZones, selectedCategories, budget } = this.state;
    let total = 0;
    let categories = [];
    let zones = selectedZones.map(zone => {
      let totalBudgetZone = 0;
      categories = selectedCategories.map(category => {
        let totalBudgetCategory = 0;
        category.zones = category.zones.filter(({ zone }) => zone);
        category.zones.forEach(item => {
          if (item.zone === zone.id) {
            totalBudgetZone =
              totalBudgetZone +
              parseFloat(
                item.zone && item.bases.actualYear ? item.bases.actualYear : 0
              );
          }
          totalBudgetCategory =
            totalBudgetCategory +
            parseFloat(
              item.zone && item.bases.actualYear ? item.bases.actualYear : 0
            );
        });

        return {
          ...category,
          total: totalBudgetCategory
        };
      });
      total = total + parseFloat(totalBudgetZone);
      return {
        ...zone,
        total: { ...zone.total, totalCategories: totalBudgetZone }
      };
    });

    const categoriesBudgetLeft = budget.totals.actualYearBudget - total;

    this.setState({
      ...this.state,
      totalCategoriesBudget: parseFloat(total),
      selectedCategories: categories,
      selectedZones: zones,
      categoriesBudgetLeft
    });
  };

  //*************   Save functionsn  ********************//
  handleCheckSaveLevel = id => {
    let { warnings, alerts } = this.state;
    if (
      (id === "LEVEL_1" && alerts.level1 && alerts.level1.isRequired) ||
      (id === "LEVEL_2" && alerts.level2 && alerts.level2.isRequired) ||
      (id === "LEVEL_3" && alerts.level3 && alerts.level3.isRequired) ||
      (id === "LEVEL_4" && alerts.level4 && alerts.level4.isRequired)
    ) {
      return;
    }
    if (
      (id === "LEVEL_1" && warnings.level1 && warnings.level1.isVisible) ||
      (id === "LEVEL_2" && warnings.level2 && warnings.level2.isVisible) ||
      (id === "LEVEL_3" && warnings.level3 && warnings.level3.isVisible) ||
      (id === "LEVEL_4" && warnings.level4 && warnings.level4.isVisible)
    ) {
      this.setState({
        ...this.state,
        displayConfirmation: true
      });
    } else {
      switch (id) {
        case "LEVEL_1":
          this.handleSaveLevel1();
          break;
        case "LEVEL_2":
          this.handleSaveLevel2();
          break;
        case "LEVEL_3":
          this.handleSaveLevel3();
          break;
        case "LEVEL_4":
          this.handleSaveLevel4();
          break;
        default:
          break;
      }
    }
  };

  handleBudgetDelegationStatus = delegations => {
    let { exceededBudgetRate } = this.state;
    let responsable = false;
    let delegated = true;
    let nbrDelegated = 0;
    delegations.forEach(delegation => {
      delegation.collaborators
        .filter(collaborator => collaborator.delegated === false)
        .forEach(collaborator => {
          if (parseFloat(collaborator.base) > 0) {
            responsable = true;
          }
        });
    });
    delegations.forEach(delegation => {
      delegation.collaborators
        .filter(collaborator => collaborator.delegation === true)
        .forEach(collaborator => {
          nbrDelegated++;
          parseFloat(collaborator.base) > 0 &&
            collaborator.delegatedCollaborators.forEach(collaborator => {
              if (collaborator.id === 999999 || collaborator.id === null) {
                delegated = false;
              }
            });
        });
    });
    return responsable && !delegated && nbrDelegated > 0
      ? BUDGET_STATUS.STATUS_DELEGATION_NOT_AFFECTED
      : Math.abs(exceededBudgetRate.toFixed(2)) === 0
        ? BUDGET_STATUS.STATUS_BUDGET_COMPLETED
        : delegated && responsable && nbrDelegated > 0
          ? BUDGET_STATUS.STATUS_BUDGET_ZONE_DELEGATION_AFFECTED
          : responsable && delegated && nbrDelegated === 0
            ? BUDGET_STATUS.STATUS_BUDGET_BY_ZONE_AFFECTED
            : BUDGET_STATUS.STATUS_DELEGATION_NOT_AFFECTED;
  };

  handleBudgetCategoryStatus = () => {
    let { totalDelegationsBudget, totalCategoriesBudget } = this.state;
    return totalCategoriesBudget === totalDelegationsBudget
      ? BUDGET_STATUS.STATUS_BUDGET_COMPLETED
      : BUDGET_STATUS.STATUS_BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED;
  };

  handleSaveLevel1 = () => {
    let status =
      this.state.budget.totals.actualYearBudget > 0
        ? BUDGET_STATUS.STATUS_GLOBAL_BUDGET_AFFECTED
        : BUDGET_STATUS.STATUS_GLOBAL_BUDGET_NOT_AFFECTED;
    let budget = {
      id: this.props.budgetData.id,
      totals: {
        hourBudget: this.state.budget.totals.actualYearBudget,
        economicBudget: this.state.budget.totals.actualYearEconomicBudget
      },
      zone: this.state.selectedZoneIds,
      client: this.props.client.id
    };
    this.saveAndRefreshSavedBudget(budget, status);
  };

  handleSaveLevel2 = () => {
    let budget = {
      id: this.props.budgetData.id,
      zones: this.state.selectedZoneIds,
      client: this.props.client.id
    };
    this.saveAndRefreshSavedBudget(budget);
  };

  handleSaveLevel3 = () => {
    const { client, budgetData } = this.props;
    const { selectedZones } = this.state;
    // let delegations = this.state.selectedZones.map(zone => {
    //   let collaborators = zone.collaborators.delegated
    //     .filter(
    //       delegated =>
    //         (delegated.id !== 999999 || delegated.id !== null) &&
    //         (delegated.base !== "" || delegated.id !== null)
    //     )
    //     .map(delegated => {
    //       return { ...delegated, delegated: true };
    //     });
    //   collaborators.push({
    //     ...zone.collaborators.principal,
    //     delegated: false
    //   });
    //   return {
    //     id: zone.id,
    //     collaborators: collaborators
    //   };
    // });
    let delegations = [];
    selectedZones.forEach(item => {
      const collaborators = Object.keys(item["responsibles"]).map(key => ({
        ...item["responsibles"][key],
        delegated: false
      }));
      collaborators.forEach(item2 => {
        if (
          item2["delegatedCollaborators"] &&
          item2["delegatedCollaborators"].length > 0
        ) {
          collaborators.push(...item2["delegatedCollaborators"]);
        }
      });

      delegations.push({
        id: item["id"],
        collaborators: collaborators
      });
    });

    let budget = {
      id: budgetData.id,
      delegations,
      client: client.id
    };
    let status = this.handleBudgetDelegationStatus(delegations);
    this.saveAndRefreshSavedBudget(budget, status);
  };

  handleSaveLevel4 = () => {
    let categories = [];

    this.state.selectedCategories.forEach(category => {
      category.zones.forEach(zone => {
        zone &&
          categories.push({
            id: zone.id,
            zone: zone.zone,
            base: zone.bases.actualYear
          });
      });
    });
    let budget = {
      id: this.props.budgetData.id,
      client: this.props.client.id,
      categories
    };
    let status = this.handleBudgetCategoryStatus();
    this.saveAndRefreshSavedBudget(budget, status);
  };

  setNewCollaborators = () => {
    const { collaborators, dispatch } = this.props;
    const newCollaborators = collaborators.map((collaborator, index) => {
      return {
        ...collaborator,
        affectedBudget: this.state.collaboratorOptions[index].budget
      };
    });
    return dispatch(setCollaborators(newCollaborators));
  };

  setNewCategories = () => {
    const newCategories = [];
    this.state.selectedCategories.forEach((item, index) => {
      if (item.zones.length > 0) {
        item.zones.forEach(zone => {
          newCategories.push({ ...zone, index });
        });
      }
    });
    return newCategories;
  };

  setNewZones = () => {
    const { selectedZones, selectedZoneIds } = this.state;
    return selectedZones.filter(item => selectedZoneIds.includes(item.id));
  };

  saveAndRefreshSavedBudget = (budget, status = "") => {
    const { periodSetting, dispatch } = this.props;
    this.setState({ fetchingLevel: true });
    dispatch(updateBudgetClient(budget, periodSetting, status))
      .then(res => {
        let {
          budget,
          selectedZones,
          activatedLevel,
          selectedZoneIds
        } = this.state;

        let newBudget = {
          ...budget
        };
        let executePrepare = true;
        switch (activatedLevel) {
          case "LEVEL_1":
            this.setNewCollaborators();
            dispatch(setBudgetData(newBudget));
            break;
          case "LEVEL_2":
            if (selectedZones.length > selectedZoneIds.length) {
              newBudget.zones = this.setNewZones();
              dispatch(setBudgetData(newBudget));
            } else if (selectedZones.length < selectedZoneIds.length) {
              dispatch(fetchBudget()).then(res => this.prepareBudgetStates());
              executePrepare = false;
            }
            break;
          case "LEVEL_3":
            newBudget.zones = { ...selectedZones };
            dispatch(setBudgetData(newBudget));
            this.setNewCollaborators();
            break;
          case "LEVEL_4":
            newBudget.categories = this.setNewCategories();
            dispatch(setBudgetData(newBudget));
            break;
          default:
            break;
        }

        this.setState(
          {
            displayConfirmation: false,
            warnings: {},
            alerts: {},
            modifiedLevel: null,
            fetchingLevel: false
          },
          () => {
            executePrepare && this.prepareBudgetStates();
          }
        );
        NotificationManager.success(_("budgetUpdated"), _("update"));
      })
      .catch(err => {
        this.setState({
          displayConfirmation: false,
          fetchingLevel: false
        });
        NotificationManager.error(_("errorUpdatingBudget"), _("error"));
      });
    this.setState({ budgetState: status });
  };

  cancelConfirmationDialog = () => {
    this.setState({
      displayConfirmation: false
    });
  };

  renderRipple = () => {
    return (
      <div className={styles.ripple_loading}>
        <img src={"/img/Ripple-1s-150px.svg"} alt="" />
      </div>
    );
  };

  render() {
    const {
      error,
      fetching,
      fetchingCategories,
      fetchingCollaborators,
      fetched
    } = this.props;
    const { budget, warnings, year, displayConfirmCloneModal } = this.state;
    return (
      <div>
        <div className={classnames(styles.settings_categories, "page-content")}>
          <SettingPageHeader
            title={_("manageBudget")}
            onBack={() => this.handleRedirectBack()}
            customAddOn={this.renderBudgetSettingTitle()}
            // years={this.renderYearSelect()}
          />
          <div className={styles.categories_block}>
            <div className={styles.header_block}>
              <div className={styles.title_block}>
                <h2 className={styles.title}>{_("budgetSetting")}</h2>
                <h3 className={styles.subtitle}>{_("manageBudgetClient")}</h3>
              </div>
              {budget && (
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    flexDirection: "column"
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "normal",
                      fontSize: "12px",
                      lineHeight: "14px",
                      color: "#6d7f92"
                    }}
                  >
                    {`${_("clonerFrom")} ${year - 1} ${_("baseOn")} :`}
                  </h3>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: 205
                    }}
                  >
                    <Button
                      style={{
                        height: 35,
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#2495E1",
                        lineHeight: "16px",
                        fontStyle: "normal",
                        borderRadius: "5px",
                        fontFamily: "Roboto",
                        background: "inherit",
                        boxSizing: "border-box",
                        textTransform: "uppercase",
                        border: "1px solid #2495E1",
                        boxShadow: "0px 4px 10px rgba(41, 57, 77, 0.1)",
                        opacity:
                          !budget.totals.lastYearBudget ||
                          budget.totals.lastYearBudget === 0
                            ? 0.4
                            : 1
                      }}
                      disabled={
                        !budget.totals.lastYearBudget ||
                        budget.totals.lastYearBudget === 0
                      }
                      onClick={() => this.displayCloneBudgetModal("BUDGET")}
                    >
                      {_("budget")}
                    </Button>
                    <Button
                      style={{
                        height: 35,
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#2495E1",
                        lineHeight: "16px",
                        fontStyle: "normal",
                        borderRadius: "5px",
                        fontFamily: "Roboto",
                        background: "inherit",
                        boxSizing: "border-box",
                        textTransform: "uppercase",
                        border: "1px solid #2495E1",
                        boxShadow: "0px 4px 10px rgba(41, 57, 77, 0.1)",
                        opacity:
                          !budget.totals.lastYearReleased ||
                          budget.totals.lastYearReleased === 0
                            ? 0.4
                            : 1
                      }}
                      disabled={
                        !budget.totals.lastYearReleased ||
                        budget.totals.lastYearReleased === 0
                      }
                      onClick={() => this.displayCloneBudgetModal("REAL_TIME")}
                    >
                      {_("temps réel")}
                    </Button>
                  </div>
                </div>
              )}
            </div>

            {fetched && !fetching && <div className={styles.divider} />}
            {(fetching || fetchingCategories || fetchingCollaborators) && !error
              ? this.renderRipple()
              : fetched &&
                (!fetching && error
                  ? this.renderBudgetSettingCallout(error.code)
                  : this.renderBudgetSettingLevels())}
          </div>
        </div>
        <TTPDialog
          showDialog={displayConfirmCloneModal}
          TTPDialog={{
            approvedAction: this.handleCloneBudget,
            abortAction: () =>
              this.setState({ displayConfirmCloneModal: false }),
            message: _("confirmationOverWriteCategoriesMessage"),
            icon: <CheckMarkIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.WARNING,
            title: "confirmationOverwriteTitle"
          }}
        />
        <TTPDialog
          showDialog={
            this.state.displayConfirmation &&
            warnings.level1 &&
            warnings.level1.isVisible
          }
          TTPDialog={{
            approvedAction: this.handleSaveLevel1,
            abortAction: this.cancelConfirmationDialog,
            message: _("confirmationOverWriteCategoriesMessage"),
            icon: <CheckMarkIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={
            this.state.displayConfirmation &&
            warnings.level2 &&
            warnings.level2.isVisible
          }
          TTPDialog={{
            approvedAction: this.handleSaveLevel2,
            abortAction: this.cancelConfirmationDialog,
            message: _("confirmationOverWriteCategoriesMessage"),
            icon: <CheckMarkIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={
            this.state.displayConfirmation &&
            warnings.level3 &&
            warnings.level3.isVisible
          }
          TTPDialog={{
            approvedAction: this.handleSaveLevel3,
            abortAction: this.cancelConfirmationDialog,
            message: _("confirmationOverWriteCategoriesMessage"),
            icon: <CheckMarkIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  periodSetting: state.budget.setting.periodSetting,
  fetching: state.budget.setting.fetching,
  fetched: state.budget.setting.fetched,
  error: state.budget.setting.error,
  fetchingCollaborators: state.budget.setting.collaborators.fetching,
  client: state.budget.setting.client,
  budgetData: state.budget.setting.budgetData,
  categories: state.categoriesSettings.items,
  fetchedCategories: state.categoriesSettings.fetched,
  fetchingCategories: state.categoriesSettings.fetching,
  collaborators: state.budget.setting.collaborators.items,
  parameterSettings: state.parameterSettings.data,
  fetchedCollaborators: state.budget.setting.collaborators.fetched,
  zoneData: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(BudgetSettings);



// WEBPACK FOOTER //
// ./src/components/BudgetSettings/BudgetSettings.js